import React from "react";

const iconDefinitions: any = {
  chevronLeft: {
    viewBox: "0 0 320 512",
    icon: (
      <path
        fill="currentColor"
        d="M224 480c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25l192-192c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l169.4 169.4c12.5 12.5 12.5 32.75 0 45.25C240.4 476.9 232.2 480 224 480z"
      />
    ),
  },
  chevronRight: {
    viewBox: "0 0 320 512",
    icon: (
      <path
        fill="currentColor"
        d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"
      />
    ),
  },
  celebrate: {
    viewBox: "0 0 512 512",
    icon: (
      <path
        fill="currentColor"
        d="M48.22 345.6l118.2 118.2l60.18-22.57L70.79 285.4L48.22 345.6zM2.035 468.7c-4.406 11.75-1.531 25 7.344 33.88C15.47 508.7 23.66 512 32 512c3.781 0 7.594-.6563 11.25-2.031l90.25-33.84l-97.63-97.63L2.035 468.7zM150.6 201.4C142.9 193.7 131.8 190.5 121.2 192.7c-10.62 2.312-19.37 9.844-23.19 20.03L83.13 252.5l176.4 176.4l39.75-14.9c10.19-3.812 17.72-12.56 20.03-23.19c2.281-10.62-.9683-21.72-8.656-29.41L150.6 201.4zM184 160c5.438 0 10.87-1.812 15.37-5.562c35.97-30 56.62-74.06 56.62-120.9V24c0-13.25-10.75-24-23.1-24s-23.1 10.75-23.1 24v9.531c0 32.56-14.34 63.19-39.37 84.03C158.4 126.1 157.1 141.2 165.6 151.4C170.3 157.1 177.1 160 184 160zM64 63.1c17.67 0 31.1-14.33 31.1-31.1c0-17.67-14.32-31.1-31.1-31.1S32 14.33 32 32C32 49.67 46.33 63.1 64 63.1zM487.1 256h-9.531C431.6 256 387.6 276.7 357.6 312.6c-8.5 10.19-7.125 25.31 3.062 33.81C365.1 350.2 370.6 352 375.1 352c6.875 0 13.69-2.938 18.44-8.625C415.3 318.3 445.9 304 478.5 304h9.531c13.25 0 23.1-10.75 23.1-24S501.2 256 487.1 256zM389.7 176c20.88-24.47 19.37-48.19 18.25-65.5c-.9687-14.97-1.062-21.97 6.844-31.22c7.875-9.219 14.78-10.19 29.66-11.53c17.25-1.562 40.91-3.688 61.84-28.16c8.594-10.06 7.438-25.22-2.656-33.84c-10.03-8.5-25.16-7.438-33.84 2.656c-7.875 9.219-14.78 10.19-29.66 11.53c-17.25 1.562-40.91 3.688-61.84 28.16c-20.88 24.47-19.37 48.19-18.25 65.5c.9687 14.97 1.062 21.97-6.844 31.22c-7.844 9.188-14.75 10.16-29.59 11.5c-17.25 1.531-40.91 3.625-61.81 28.09C253.2 194.5 254.3 209.7 264.4 218.3C268.9 222.1 274.5 224 279.1 224c6.781 0 13.5-2.844 18.25-8.406c7.844-9.188 14.75-10.16 29.56-11.5C345.1 202.6 368.7 200.5 389.7 176zM479.1 416c-17.67 0-31.1 14.33-31.1 31.1c0 17.67 14.33 31.1 31.1 31.1s31.1-14.33 31.1-31.1C511.1 430.3 497.7 416 479.1 416zM479.1 128c-17.67 0-31.1 14.33-31.1 31.1c0 17.67 14.33 31.1 31.1 31.1s31.1-14.33 31.1-31.1C511.1 142.3 497.7 128 479.1 128z"
      />
    ),
  },
  caretDown: {
    viewBox: "0 0 512 300",
    icon: (
      <g
        transform="translate(0.000000,291.624595) scale(0.165696,-0.165696)"
        stroke="none"
      >
        <path
          fill="currentColor"
          d="M198 1716 c-114 -41 -167 -170 -112 -276 17 -34 1346 -1360 1381
        -1379 15 -8 54 -14 85 -14 46 0 65 5 95 26 40 27 1331 1315 1358 1353 26 38
        35 101 20 156 -14 57 -53 103 -110 129 -38 18 -96 19 -1360 18 -1070 0 -1327
        -2 -1357 -13z"
        />
      </g>
    ),
  },
  map: {
    viewBox: "0 0 79.4 31",
    icon: (
      <g>
        <path
          fill="#3FB54B"
          d="M24.3,1.8C24.7,2,25.2,1.9,25.6,2c3.3,0.7,5.4,3,5.8,6.3c0.1,0.9,0.2,1.7,0.2,2.6c0,3,0,5.9,0,8.9
			c0,0.9-0.2,1.2-1.2,1.2c-1.2,0-2.4,0-3.6,0c-0.7,0-0.9-0.3-0.9-1c0-3.1,0-6.1,0-9.2c0-0.6,0-1.2-0.2-1.7c-0.4-1.4-1.5-2.1-3.1-1.9
			c-1.3,0.1-2.2,1-2.4,2.5c0,0.4,0,0.8,0,1.2c0,3,0,6,0,9.1c0,0.9-0.2,1.1-1.1,1.1c-1.2,0-2.3,0-3.5,0c-0.8,0-1.1-0.2-1.1-1.1
			c0-3.1,0-6.2,0-9.4c0-0.4,0-0.8-0.1-1.2C14,7.8,13,7.1,11.4,7.1C9.9,7.2,8.9,8,8.7,9.5c-0.1,0.4-0.1,0.8-0.1,1.3
			c0,3.1,0,6.1,0,9.2c0,0.7-0.2,1-1,1c-1.2,0-2.4,0-3.7,0c-0.5,0-0.8-0.1-1-0.6c0-3.8,0-7.6,0-11.4c0.2-0.2,0.1-0.5,0.2-0.8
			C3.6,4.9,5.7,2.7,9,2c0.4-0.1,0.8-0.1,1.2-0.2c0.5,0,1,0,1.6,0c0.1,0.2,0.2,0.1,0.3,0.1c1.8,0.2,3.4,0.9,4.7,2.3
			c0.2,0.2,0.3,0.4,0.5,0.6c1.1-1.5,2.6-2.3,4.3-2.7C22,1.9,22.4,2,22.8,1.8C23.3,1.8,23.8,1.8,24.3,1.8z"
        />
        <path
          fill="#3FB54B"
          d="M65.6,1.8C66.1,2,66.5,1.9,67,2c4.6,0.9,7.6,4.5,7.8,9.1c0.1,2.7-0.5,5.2-2.3,7.3c-2.4,2.7-6.4,3.8-9.6,2.4
			c-0.9-0.4-1.7-1-2.4-1.8c-0.1,0.2-0.1,0.4-0.1,0.5c0,2.7,0,5.5,0,8.2c0,0.8-0.2,1.1-1,1.1c-1.3,0-2.5,0-3.8,0
			c-0.7,0-0.9-0.2-0.9-0.9c0-5.5,0-11,0-16.5c0-3.3,1.2-6,4-8c1.4-1,3.1-1.5,4.8-1.7c0.1,0,0.3,0.1,0.4-0.1
			C64.4,1.8,65,1.8,65.6,1.8z M64.7,16.2c2.4,0.1,4.3-1.7,4.3-4.2c0.1-2.8-1.6-4.7-4.1-4.8c-2.6-0.1-4.4,1.7-4.5,4.2
			C60.3,14.2,62,16.1,64.7,16.2z"
        />
        <path
          fill="#3FB54B"
          d="M43.9,1.8c0.5,0.2,1,0.2,1.5,0.3c4.5,0.9,7.4,4.3,7.6,8.9c0.1,3.1,0,6.1,0,9.2c0,0.6-0.3,0.9-0.9,0.9
			c-1.1,0-2.2,0-3.4,0c-0.7,0-0.9-0.3-0.9-1c0-0.6,0-1.2,0-2c-0.3,0.6-0.6,1-1,1.4c-1.5,1.6-3.3,2.1-5.4,1.9c-4.7-0.4-8-3.8-8.4-8.5
			c-0.2-2.2,0.1-4.4,1.3-6.3c1.7-2.9,4.3-4.3,7.5-4.7c0.1,0,0.3,0.1,0.3-0.1C42.7,1.8,43.3,1.8,43.9,1.8z M47.3,11.7
			c0-3.2-2.7-5.3-5.7-4.3c-1.7,0.5-2.8,2-2.9,4c-0.1,3.1,2,5.1,5.1,4.7C45.9,15.8,47.3,14,47.3,11.7z"
        />
        <path
          fill="#3FB54B"
          d="M77.7,3.8c0,1.1-0.8,1.9-1.9,1.9c-1.1,0-1.9-0.9-1.9-1.9c0-1,0.9-1.9,1.9-1.9C76.8,1.9,77.7,2.7,77.7,3.8z
			 M74.1,3.8c0,0.9,0.7,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7C74.8,2.1,74.1,2.8,74.1,3.8z"
        />
        <path
          fill="#3FB54B"
          d="M75.5,4.1c-0.2,0.2,0.2,0.7-0.4,0.6c0-0.6,0-1.3,0-1.9c0.2-0.1,0.5,0,0.7,0c0.3,0,0.7,0,0.9,0.4
			c0.2,0.4-0.1,0.6-0.3,0.8c0.1,0.2,0.3,0.4,0.4,0.6c-0.3,0.2-0.5,0-0.6-0.2C75.9,4.2,75.8,3.9,75.5,4.1z M75.4,3.7
			c0.3,0,0.6,0.1,0.8-0.2c0.1-0.1,0.1-0.2,0-0.3c-0.2-0.2-0.5-0.1-0.7-0.1C75.4,3.3,75.4,3.5,75.4,3.7z"
        />
      </g>
    ),
  },
  mapGrowth: {
    viewBox: "0 0 179.2 31",
    icon: (
      <g>
        <path
          fill="#3FB54B"
          d="M16.9,8.7c0.2-0.2,0.4-0.4,0.5-0.6c0,0,0-0.1,0.1-0.1c0.4-0.3,0.8-0.6,1.3-0.9c0.3-0.2,0.6-0.3,1-0.4
			c0.4-0.1,0.8-0.2,1.2-0.3c0.4,0,0.9-0.1,1.3-0.1c0.4,0,0.9,0,1.3,0.1c0.6,0.1,1.3,0.3,1.8,0.6c0.4,0.2,0.8,0.5,1.1,0.7
			c0.1,0.1,0.2,0.2,0.2,0.3c0.5,0.4,0.9,1,1.2,1.6c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.2,0.1,0.4,0.2,0.6c0.2,0.8,0.3,1.5,0.3,2.3
			c0,2.6,0,5.2,0,7.8c0,0.2,0,0.4-0.1,0.5c-0.1,0.2-0.3,0.3-0.5,0.3c-0.1,0-0.1,0-0.2,0c-1,0-2.1,0-3.1,0c-0.1,0-0.2,0-0.3,0
			c-0.3,0-0.6-0.3-0.6-0.6c0-0.1,0-0.3,0-0.4c0-2.5,0-5,0-7.5c0-0.5,0-1-0.2-1.4c-0.2-0.5-0.5-0.9-0.9-1.2c-0.2-0.1-0.5-0.2-0.8-0.3
			c-0.5-0.1-1,0-1.5,0.1c-0.2,0.1-0.4,0.2-0.6,0.4c0,0-0.1,0.1-0.1,0.1c-0.4,0.3-0.5,0.8-0.6,1.2c-0.1,0.5-0.1,1.1-0.1,1.6
			c0,2.3,0,4.7,0,7c0,0.2,0,0.4-0.1,0.5C19,21.9,18.8,22,18.6,22c-0.4,0-0.8,0-1.2,0c-0.7,0-1.4,0-2.1,0c-0.2,0-0.3,0-0.5-0.1
			c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.2,0-0.3,0-0.5c0-1.6,0-3.3,0-4.9c0-1,0-2,0-3c0-0.5-0.1-0.9-0.3-1.4c-0.3-0.6-0.7-0.9-1.3-1.1
			c-0.6-0.2-1.2-0.1-1.8,0.1c-0.3,0.1-0.5,0.3-0.7,0.5c-0.3,0.3-0.4,0.6-0.5,0.9c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.3,0,0.5,0,0.8
			c0,2.6,0,5.2,0,7.8c0,0.3-0.1,0.5-0.4,0.7c-0.1,0-0.2,0-0.2,0c-1.2,0-2.3,0-3.5,0c-0.2,0-0.3-0.1-0.4-0.2
			c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.2,0-0.3c0-2.5,0-5.1,0-7.6c0-1,0.1-1.9,0.4-2.9c0.2-0.7,0.5-1.4,1-2C6.7,8.3,7,8,7.3,7.7
			C7.6,7.5,8,7.2,8.3,7c0.3-0.2,0.7-0.3,1-0.4c0.6-0.2,1.2-0.3,1.8-0.3c0.6-0.1,1.3,0,1.9,0.1c0.7,0.1,1.4,0.3,2.1,0.7
			c0.2,0.1,0.5,0.3,0.7,0.5C16,7.7,16.2,7.8,16.3,8c0.1,0.2,0.3,0.3,0.4,0.5C16.8,8.6,16.8,8.6,16.9,8.7z"
        />
        <path
          fill="#3FB54B"
          d="M52.5,20.5c0,0.1,0,0.1,0,0.2c0,2.3,0,4.7,0,7c0,0.1,0,0.2,0,0.3c0,0.4-0.3,0.7-0.7,0.7c-1.1,0-2.2,0-3.3,0
			c-0.2,0-0.4-0.1-0.6-0.3c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3c0-4.4,0-8.9,0-13.3c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0.1-0.6
			c0-0.2,0.1-0.4,0.1-0.6c0.1-0.4,0.2-0.9,0.3-1.3c0.2-0.5,0.4-0.9,0.6-1.4c0.1-0.1,0.1-0.3,0.2-0.4c0.2-0.2,0.3-0.4,0.5-0.6
			c0.2-0.3,0.4-0.5,0.7-0.7c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.1,0.4-0.3,0.6-0.4c0.3-0.2,0.6-0.4,1-0.5c0.2-0.1,0.4-0.1,0.6-0.2
			c0.3-0.1,0.5-0.2,0.8-0.2C54,6.4,54.5,6.4,55,6.3c0.5,0,1-0.1,1.5,0c0.4,0,0.9,0.1,1.3,0.2c0.6,0.1,1.1,0.3,1.6,0.5
			c0.7,0.3,1.3,0.6,1.8,1.1c0.2,0.1,0.3,0.3,0.5,0.4c0.2,0.2,0.4,0.4,0.5,0.5c0.3,0.3,0.5,0.6,0.7,0.9c0.2,0.3,0.3,0.6,0.5,0.8
			c0.2,0.5,0.4,0.9,0.5,1.4c0.2,0.9,0.3,1.8,0.3,2.7c0,0.8-0.2,1.7-0.4,2.5c-0.1,0.4-0.2,0.7-0.4,1c-0.3,0.5-0.5,1-0.9,1.4
			c-0.2,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.4-0.8,0.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3,0.2-0.5,0.3-0.8,0.5c-0.3,0.2-0.6,0.3-0.9,0.4
			c-0.6,0.2-1.2,0.3-1.8,0.4c-0.6,0.1-1.3,0-1.9-0.1c-0.5-0.1-0.9-0.2-1.3-0.4c-0.5-0.2-0.9-0.5-1.2-0.8c-0.2-0.2-0.4-0.3-0.5-0.5
			C52.6,20.6,52.5,20.5,52.5,20.5z M59.5,14.4c0-0.4,0-0.8-0.1-1.1c-0.1-0.4-0.3-0.9-0.6-1.2c-0.4-0.6-1-1-1.7-1.2
			c-0.5-0.2-1.1-0.2-1.7-0.1c-0.7,0.1-1.3,0.4-1.9,0.8c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.1-0.2,0.2-0.2,0.3c-0.2,0.4-0.3,0.7-0.4,1.2
			c-0.1,0.5-0.1,1,0,1.5c0,0.3,0.1,0.6,0.2,0.9c0.1,0.1,0.2,0.3,0.2,0.4c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.3,0.3,0.5,0.5
			c0.2,0.2,0.5,0.4,0.8,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.7,0.1,1.3,0.1,2,0c0.9-0.3,1.6-0.8,2.1-1.7C59.4,15.6,59.5,15,59.5,14.4z"
        />
        <path
          fill="#3FB54B"
          d="M42,19.7c-0.1,0-0.1,0.1-0.1,0.1c-0.3,0.6-0.6,1.1-1.1,1.5c-0.5,0.4-1,0.7-1.6,0.8c-1,0.3-2,0.4-3,0.3
			c-0.4-0.1-0.8-0.1-1.2-0.3c-0.3-0.1-0.7-0.2-1-0.4c-0.3-0.2-0.7-0.4-1-0.6c-0.2-0.1-0.4-0.3-0.6-0.5c-0.1-0.1-0.2-0.2-0.3-0.2
			c0,0,0,0-0.1-0.1c-0.3-0.4-0.7-0.7-0.9-1.1c-0.2-0.3-0.3-0.5-0.5-0.8c-0.3-0.7-0.5-1.4-0.7-2.1c-0.1-0.7-0.2-1.4-0.2-2.1
			c0-1.6,0.4-3.1,1.3-4.5c0.1-0.2,0.2-0.4,0.4-0.6c0.3-0.3,0.6-0.6,0.9-0.9c0.3-0.2,0.5-0.4,0.8-0.6c0.1-0.1,0.3-0.2,0.4-0.3
			C34.1,7.2,34.6,7,35,6.8c0.3-0.1,0.6-0.2,1-0.3c0.3-0.1,0.5-0.1,0.8-0.2c0.6-0.1,1.3-0.1,1.9-0.1c0.4,0,0.8,0.1,1.1,0.1
			c0.6,0.1,1.3,0.3,1.8,0.5c0.5,0.2,1,0.5,1.4,0.8c0.4,0.2,0.7,0.5,1,0.8c1.1,1.1,1.8,2.5,2.1,4c0.1,0.7,0.2,1.5,0.2,2.2
			c0,2.1,0,4.2,0,6.2c0,0.2,0,0.3,0,0.5C46.3,21.8,46,22,45.7,22c-0.7,0-1.4,0-2.2,0c-0.3,0-0.5,0-0.8,0c-0.2,0-0.4-0.1-0.5-0.2
			c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.5,0-0.9,0-1.4C42.1,19.9,42.1,19.8,42,19.7z M41.7,14.3c0-0.3,0-0.7-0.1-1c-0.3-1-0.9-1.8-1.8-2.2
			c-0.8-0.4-1.7-0.4-2.6-0.2c-0.9,0.2-1.5,0.8-2,1.5c-0.3,0.4-0.4,0.9-0.5,1.4c-0.1,0.8,0,1.6,0.3,2.3c0.2,0.5,0.5,0.9,1,1.3
			c0.3,0.3,0.6,0.4,1,0.6c0.2,0.1,0.5,0.1,0.7,0.2c0.5,0,1.1,0,1.6-0.1c0.9-0.2,1.5-0.7,2-1.5C41.5,15.8,41.7,15.1,41.7,14.3z"
        />
        <path
          fill="#444344"
          d="M126.1,19.4c0.1-0.4,0.2-0.7,0.4-1.1c0.1-0.2,0.1-0.5,0.2-0.7c0.9-2.6,1.7-5.1,2.5-7.7
			c0.3-0.8,0.5-1.6,0.8-2.4c0.1-0.3,0.2-0.6,0.3-0.8c0-0.1,0.1-0.1,0.2-0.1c0.4,0,0.8,0,1.2,0c0.1,0,0.1,0,0.2,0.1
			c0.3,0.9,0.6,1.7,0.8,2.6c0.2,0.5,0.4,1,0.5,1.6c0.1,0.3,0.2,0.6,0.3,1c0.3,0.9,0.6,1.8,0.9,2.7c0.2,0.5,0.3,0.9,0.4,1.4
			c0.1,0.4,0.2,0.8,0.4,1.1c0.3,0.7,0.4,1.3,0.7,2c0.1,0.2,0.1,0.3,0.2,0.5c0,0,0,0,0,0c0.2-0.6,0.4-1.2,0.6-1.7
			c0.5-1.3,0.9-2.6,1.4-3.9c0.4-1.2,0.8-2.4,1.3-3.6c0.1-0.4,0.2-0.8,0.4-1.2c0.2-0.4,0.3-0.9,0.5-1.3c0.1-0.3,0.2-0.6,0.3-0.9
			c0-0.1,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.5,0,1,0,1.5,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0.1c0,0.1-0.1,0.2-0.1,0.3
			c-0.2,0.6-0.5,1.3-0.7,1.9c-0.2,0.7-0.5,1.3-0.7,2c-0.4,1-0.7,2-1.1,3c-0.4,1.1-0.8,2.2-1.2,3.3c-0.4,1.1-0.8,2.1-1.1,3.2
			c-0.2,0.6-0.4,1.1-0.6,1.7c0,0.1-0.1,0.1-0.2,0.1c-0.4,0-0.9,0-1.3,0c-0.1,0-0.1,0-0.1-0.1c-0.2-0.8-0.5-1.5-0.8-2.3
			c-0.3-1-0.7-2.1-1-3.1c-0.6-1.7-1.2-3.4-1.7-5.1c-0.1-0.4-0.3-0.8-0.4-1.2c-0.1-0.2-0.1-0.5-0.2-0.7c-0.1,0.1-0.1,0.2-0.1,0.3
			c-0.4,1.2-0.8,2.4-1.2,3.7c-0.4,1.2-0.8,2.4-1.2,3.6c-0.5,1.6-1.1,3.2-1.6,4.8c-0.1,0.2-0.1,0.2-0.2,0.2c-0.4,0-0.8,0-1.1,0
			c-0.1,0-0.2,0-0.2-0.2c-0.6-1.6-1.1-3.2-1.7-4.8c-0.9-2.4-1.7-4.9-2.6-7.3c-0.3-0.7-0.5-1.4-0.8-2.1c-0.1-0.3-0.2-0.6-0.3-0.9
			c0-0.1-0.1-0.2-0.1-0.2c0.1-0.1,0.2,0,0.3,0c0.5,0,1,0,1.5,0c0.2,0,0.2,0,0.2,0.2c0.8,2.2,1.5,4.4,2.3,6.7
			c0.5,1.3,0.9,2.6,1.4,3.9c0.2,0.6,0.5,1.3,0.7,1.9C126,19.3,126,19.4,126.1,19.4z"
        />
        <path
          fill="#444344"
          d="M99.7,22.1c-0.1,0-0.2,0-0.3,0c-0.5,0-1.1,0-1.6,0c-0.2,0-0.3,0-0.4-0.2c-0.2-0.3-0.4-0.6-0.7-0.9
			c-0.5-0.7-1-1.3-1.5-2c-0.5-0.7-1-1.3-1.5-2c-0.2-0.3-0.4-0.6-0.6-0.9c0-0.1-0.1-0.1-0.1-0.1c-1.4,0-2.8,0-4.1,0
			c-0.1,0-0.1,0-0.1,0.1c0,0.3,0,0.5,0,0.8c0,1.6,0,3.3,0,4.9c0,0,0,0,0,0.1c0,0.2,0,0.2-0.2,0.2c-0.5,0-1,0-1.4,0
			c-0.2,0-0.2,0-0.2-0.2c0-0.8,0-1.6,0-2.4c0-2.6,0-5.2,0-7.7c0-1.5,0-3,0-4.6c0-0.2,0-0.3,0-0.5c0-0.1,0-0.1,0.1-0.1
			c0.1,0,0.2,0,0.3,0c2.1,0,4.2,0,6.3,0c0.9,0,1.7,0.1,2.6,0.4c0.8,0.3,1.5,0.7,2,1.3c0.4,0.5,0.7,1.1,0.9,1.8
			c0.2,0.8,0.2,1.6,0,2.4c-0.2,0.8-0.6,1.5-1.2,2c-0.6,0.5-1.3,0.9-2.1,1.1c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.1,0-0.2,0
			c-0.1,0-0.1,0.1-0.1,0.2c0.2,0.3,0.4,0.5,0.6,0.8c0.5,0.6,0.9,1.2,1.4,1.9c0.6,0.7,1.1,1.5,1.7,2.2c0.1,0.2,0.3,0.4,0.4,0.6
			c0.1,0.2,0.3,0.4,0.4,0.5C99.7,22,99.7,22,99.7,22.1z M88.7,11.4C88.7,11.4,88.7,11.4,88.7,11.4c0,1,0,1.9,0,2.9
			c0,0.3,0,0.2,0.2,0.2c1.4,0,2.8,0,4.2,0c0.3,0,0.7,0,1,0c0.5-0.1,1-0.2,1.5-0.4c0.3-0.1,0.5-0.3,0.8-0.5c0.3-0.2,0.5-0.5,0.7-0.8
			c0.1-0.2,0.2-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.1-0.7c0-0.3,0-0.6-0.1-1c-0.1-0.3-0.2-0.6-0.4-0.9c-0.3-0.5-0.8-0.8-1.3-1
			c-0.6-0.2-1.2-0.4-1.8-0.4c-1.2,0-2.5,0-3.7,0c-0.4,0-0.8,0-1.2,0c-0.2,0-0.2,0-0.2,0.2c0,0.1,0,0.1,0,0.2
			C88.7,9.6,88.7,10.5,88.7,11.4z"
        />
        <path
          fill="#444344"
          d="M118.1,14.3c0,1-0.2,2-0.6,3c-0.3,0.8-0.8,1.6-1.4,2.3c-0.3,0.4-0.7,0.7-1.1,1.1c-0.3,0.2-0.6,0.4-0.9,0.6
			c-0.5,0.3-1,0.5-1.6,0.7c-0.5,0.2-1.1,0.3-1.7,0.3c-0.7,0.1-1.4,0-2.1-0.1c-0.7-0.1-1.3-0.3-2-0.6c-0.5-0.2-1-0.5-1.5-0.9
			c-0.2-0.1-0.3-0.3-0.5-0.4c-0.3-0.2-0.5-0.5-0.7-0.7c-0.2-0.3-0.5-0.6-0.7-0.9c-0.2-0.3-0.4-0.6-0.5-0.9c-0.3-0.7-0.5-1.4-0.6-2.1
			c-0.3-1.7,0-3.4,0.7-5c0.1-0.3,0.3-0.6,0.5-0.8c0.3-0.6,0.8-1.1,1.3-1.5c0.7-0.6,1.4-1.1,2.2-1.4c0.3-0.1,0.7-0.3,1-0.4
			c0.4-0.1,0.8-0.2,1.2-0.2c0.8-0.1,1.6-0.1,2.4,0.1c0.4,0.1,0.8,0.2,1.2,0.3c0.9,0.3,1.7,0.7,2.4,1.3c1.3,1.1,2.2,2.5,2.6,4.1
			c0.1,0.6,0.2,1.2,0.3,1.7C118.1,14.1,118.1,14.2,118.1,14.3z M116.2,14.4c0-0.5,0-1-0.1-1.4c-0.1-0.3-0.1-0.5-0.2-0.8
			c-0.2-0.5-0.4-1.1-0.7-1.5c-0.2-0.4-0.5-0.7-0.8-1c-0.3-0.3-0.6-0.5-0.9-0.7c-0.1-0.1-0.2-0.2-0.4-0.2c-0.3-0.1-0.6-0.3-0.9-0.4
			c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0-0.4,0-0.5-0.1c-0.7-0.1-1.4,0-2.1,0.3c-0.8,0.2-1.5,0.6-2.1,1.2c-0.4,0.4-0.8,0.8-1.1,1.3
			c-0.4,0.6-0.7,1.3-0.8,2c-0.1,0.6-0.2,1.2-0.2,1.8c0,0.6,0.1,1.3,0.3,1.9c0.3,1.1,0.9,2.1,1.8,2.8c1.3,1.2,2.9,1.6,4.7,1.5
			c1.7-0.2,3.1-1,4.1-2.4c0.3-0.4,0.5-0.8,0.7-1.2c0.2-0.4,0.3-0.8,0.4-1.2C116.2,15.4,116.2,14.9,116.2,14.4z"
        />
        <path
          fill="#444344"
          d="M81.3,9.7c-0.1-0.1-0.2-0.2-0.4-0.3c-0.7-0.5-1.4-1-2.2-1.2C78.1,8.1,77.6,8,77,8c-0.7,0-1.4,0-2.1,0.2
			c-0.2,0.1-0.4,0.1-0.6,0.2c-0.7,0.3-1.4,0.8-1.9,1.4c-0.9,1-1.4,2.1-1.6,3.4c-0.2,1.2-0.1,2.4,0.3,3.6c0.8,2.1,2.2,3.4,4.4,3.9
			c2,0.4,3.9-0.1,5.6-1.2c0.2-0.1,0.2-0.2,0.2-0.4c0-1,0-1.9,0-2.9c0-0.2,0-0.4,0-0.5c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0
			c-1.4,0-2.8,0-4.2,0c-0.2,0-0.2,0-0.2-0.2c0-0.4,0-0.8,0-1.2c0-0.2,0-0.2,0.2-0.2c0.9,0,1.8,0,2.7,0c1.1,0,2.2,0,3.3,0
			c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c0,1.9,0,3.8,0,5.7c0,0.2-0.1,0.3-0.2,0.4c-1,0.8-2.1,1.4-3.3,1.8
			c-1,0.3-2,0.5-3.1,0.4c-1.3,0-2.6-0.3-3.8-1C72,21,71.5,20.6,70.9,20c-0.4-0.4-0.7-0.9-1-1.4c-0.1-0.1-0.2-0.2-0.2-0.4
			c-0.4-0.9-0.7-1.9-0.8-2.9c-0.1-1.1,0-2.3,0.3-3.4c0.2-0.7,0.5-1.3,0.9-1.9c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.5-0.6,0.7-0.8
			c0.6-0.6,1.4-1.1,2.2-1.4c0.3-0.1,0.5-0.2,0.8-0.3c0.4-0.1,0.9-0.2,1.3-0.3c1-0.1,1.9-0.1,2.9,0.1c0.6,0.1,1.1,0.3,1.6,0.5
			c0.8,0.3,1.5,0.8,2.1,1.3c0.1,0.1,0.1,0.1,0.1,0.2C82,8.9,81.6,9.3,81.3,9.7z"
        />
        <path
          fill="#444344"
          d="M159.9,14.3c0-2.4,0-4.7,0-7.1c0-0.2,0-0.3,0-0.5c0-0.1,0-0.1,0.1-0.1c0.5,0,1,0,1.5,0c0.1,0,0.1,0,0.1,0.1
			c0,0.1,0,0.1,0,0.2c0,2.1,0,4.2,0,6.3c0,0.3,0,0.2,0.2,0.2c2.8,0,5.7,0,8.5,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1-0.1
			c0,0,0-0.1,0-0.1c0-2.2,0-4.3,0-6.5c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.1c0.5,0,1,0,1.5,0c0.1,0,0.1,0,0.1,0.1c0,0.1,0,0.1,0,0.2
			c0,5,0,10,0,15c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.1,0.1c-0.5,0-1,0-1.5,0c-0.1,0-0.1,0-0.1-0.2c0-2.1,0-4.2,0-6.3c0-0.1,0-0.3,0-0.4
			c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0c-2.8,0-5.6,0-8.4,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.2,0,0.3
			c0,2.1,0,4.2,0,6.3c0,0.3,0,0.2-0.2,0.2c-0.5,0-0.9,0-1.4,0c-0.2,0-0.2,0-0.2-0.2c0-2,0-4.1,0-6.1
			C159.9,15.3,159.9,14.8,159.9,14.3C159.9,14.3,159.9,14.3,159.9,14.3z"
        />
        <path
          fill="#444344"
          d="M151.4,15.2c0,2.2,0,4.5,0,6.7c0,0,0,0.1,0,0.1c0,0.1,0,0.1-0.2,0.1c-0.5,0-1,0-1.4,0c-0.2,0-0.2,0-0.2-0.2
			c0-0.3,0-0.5,0-0.8c0-4.2,0-8.4,0-12.7c0-0.2,0-0.2-0.2-0.2c-1.6,0-3.2,0-4.8,0c-0.2,0-0.2,0-0.2-0.2c0-0.4,0-0.8,0-1.2
			c0-0.2,0-0.2,0.2-0.2c1.2,0,2.4,0,3.7,0c2.7,0,5.4,0,8.1,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.1,0.1c0,0.2,0,0.3,0,0.5
			c0,0.3,0,0.6,0,0.9c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0c-1.5,0-3.1,0-4.6,0c0,0-0.1,0-0.1,0c-0.2,0-0.2,0-0.2,0.2c0,2,0,4,0,6
			C151.4,14.7,151.4,14.9,151.4,15.2C151.4,15.2,151.4,15.2,151.4,15.2z"
        />
        <path
          fill="#3FB54B"
          d="M63.5,7.9c0-0.9,0.7-1.6,1.6-1.5c0.9,0,1.5,0.6,1.5,1.6c0,0.9-0.7,1.6-1.6,1.6C64.1,9.4,63.5,8.7,63.5,7.9z
			 M66.4,7.9c0-0.8-0.6-1.4-1.4-1.3c-0.8,0-1.3,0.7-1.3,1.4c0,0.8,0.6,1.4,1.4,1.4C65.8,9.3,66.4,8.7,66.4,7.9z"
        />
        <path
          fill="#444344"
          d="M175.7,7c-0.1,0.2-0.3,0.4-0.5,0.7c-0.1-0.3-0.3-0.5-0.4-0.7c-0.1,0,0,0.1,0,0.1c0,0.2,0,0.5,0,0.7
			c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1c0-0.4,0-0.7,0-1.1c0-0.1,0-0.1,0.1-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.3
			c0.1,0.1,0.2,0.3,0.3,0.4c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0,0.1,0.1c0,0.4,0,0.8,0,1.2
			c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1c0-0.2,0-0.4,0-0.6C175.7,7.2,175.7,7.1,175.7,7C175.7,7,175.7,7,175.7,7z"
        />
        <path
          fill="#444344"
          d="M173.6,7.4c0-0.2,0-0.3,0-0.5c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1-0.1
			c0-0.1,0-0.1,0.1-0.1c0.3,0,0.6,0,0.9,0c0.1,0,0.1,0,0.1,0.1c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0.1
			c0,0.3,0,0.6,0,0.9c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1C173.6,7.7,173.6,7.5,173.6,7.4z"
        />
        <path
          fill="#3FB54B"
          d="M65.8,8.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.1
			c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1-0.1,0.1c-0.2,0-0.2,0-0.2-0.2c0-0.4,0-0.8,0-1.3c0-0.2,0-0.2,0.2-0.2
			c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0,0.3,0.1c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2,0,0.4-0.2,0.5c-0.1,0.1-0.1,0.1,0,0.2
			c0.1,0.1,0.1,0.2,0.2,0.3C65.8,8.5,65.8,8.5,65.8,8.6z M65.1,7.8c0,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2
			c-0.1,0-0.2,0-0.2,0c-0.3,0-0.2,0-0.2,0.2C64.8,7.9,64.7,7.8,65.1,7.8z"
        />
      </g>
    ),
  },
  logo: {
    viewBox: "0 0 23 23",
    icon: (
      <g id="WqTwJY.tif">
        <path
          d="M7.54,12.49a8.82,8.82,0,0,1-2.7.34,4.41,4.41,0,0,1-3.41-1.54,4.23,4.23,0,0,1-.65-4.2,9.05,9.05,0,0,1,6-6A11.25,11.25,0,0,1,13,.78a3.9,3.9,0,0,1,2.25,1.37.46.46,0,0,0,.34.12,5.66,5.66,0,0,1,2.34.33,4.34,4.34,0,0,1,2.69,3.32A14.29,14.29,0,0,1,20.87,8a.53.53,0,0,0,.21.42,3.84,3.84,0,0,1,1.33,2.44,3.21,3.21,0,0,1-1.61,3.68,11.39,11.39,0,0,1-1.26.63c-.09,0-.2.13-.21.21a3.46,3.46,0,0,1-4.4,2.35,7,7,0,0,1-3-1.79c-.59-.57-1.09-1.23-1.65-1.84a.44.44,0,0,0-.31-.17,2.48,2.48,0,0,1-2.39-1.33Z"
          fill="currentColor"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
        <path
          d="M22.28,11a3.94,3.94,0,0,0-1.56-2.69c0-.19,0-.41,0-.65a6.71,6.71,0,0,0-.84-3.27,4.32,4.32,0,0,0-3.93-2,5.31,5.31,0,0,0-.68,0,3.18,3.18,0,0,0-.63-.69A6,6,0,0,0,10.77.6,16,16,0,0,0,8.7.76,6.6,6.6,0,0,0,8,.89,9.63,9.63,0,0,0,2.13,4.61,8.48,8.48,0,0,0,.86,7.12a4.85,4.85,0,0,0-.17,2.3,4,4,0,0,0,.42,1.16v0a3.74,3.74,0,0,0,.68.9,4.06,4.06,0,0,0,1.73,1,6.09,6.09,0,0,0,.85.17,5.85,5.85,0,0,0,.73,0,6.51,6.51,0,0,0,.75,0,7,7,0,0,0,.78-.11c.32-.06.64-.14,1-.23A2.58,2.58,0,0,0,8,13a2.31,2.31,0,0,0,1.6.77h.21l.38,0a12.84,12.84,0,0,0,1.09,1.37,10.3,10.3,0,0,0,1.5,1.37,6.86,6.86,0,0,0,.88.56,5.62,5.62,0,0,0,1,.44,5.19,5.19,0,0,0,.87.19,3.69,3.69,0,0,0,.58,0h.23a3.9,3.9,0,0,0,.46-.12,3.41,3.41,0,0,0,.86-.36,3,3,0,0,0,1.46-1.85v0a2.21,2.21,0,0,0,.05-.25h0a7,7,0,0,0,1-.44,4.79,4.79,0,0,0,.75-.48A3,3,0,0,0,22.27,11M8.12,1.59c.22-.05.45-.09.68-.12a16.33,16.33,0,0,1,2-.15c3.67,0,4.07,1.83,4.07,1.83A8.3,8.3,0,0,1,16,3.06C19.41,3.06,20,6,20,7.64A11.56,11.56,0,0,0,12.41,2.9a10.3,10.3,0,0,0-6.15.83c-2,1.09-3.45,2.67-4.51,6.52a3.51,3.51,0,0,1-.36-1C1,7.14,3.11,2.64,8.12,1.59ZM10.35,13h0ZM14,16.4a9.58,9.58,0,0,0-1-3.42,2.91,2.91,0,0,0-1.74-1.48.37.37,0,0,0-.44.27.36.36,0,0,0,.27.44,2.15,2.15,0,0,1,1.28,1.13,7.84,7.84,0,0,1,.81,2.55,9.46,9.46,0,0,1-1.4-1.28A5.69,5.69,0,0,0,11,13.37l-.26-.31-.15-.16c-.63-.63-1.11-1.35-.4-2.16a1,1,0,0,1,.88-.38,3.77,3.77,0,0,1,2.5,1.81,5.9,5.9,0,0,1,.89,2,18.55,18.55,0,0,1,.51,2.57A5.41,5.41,0,0,1,14,16.4Zm2.2.58h-.09a4,4,0,0,1-.49,0A17.89,17.89,0,0,0,15.12,14a6.58,6.58,0,0,0-1-2.28,4.37,4.37,0,0,0-3-2.11,1.76,1.76,0,0,0-1.47.63A2,2,0,0,0,9.67,13a1.56,1.56,0,0,1-1.12-.52,4.38,4.38,0,0,1-.35-.91,2.75,2.75,0,0,1,1.3-2.5,3.06,3.06,0,0,1,3.2,0c1.78,1,3.85,3.54,3.93,7.76A2.5,2.5,0,0,1,16.24,17Zm2.22-1.8a2.27,2.27,0,0,1-1.11,1.41C17.18,12.21,15,9.5,13,8.48a3.76,3.76,0,0,0-3.94,0,3.48,3.48,0,0,0-1.62,3.11,8.08,8.08,0,0,1-1,.24,1.66,1.66,0,0,1-.06-.21A3.16,3.16,0,0,1,7.05,9a4.67,4.67,0,0,1,3.29-1.95A6.35,6.35,0,0,1,14.7,8.39C16.44,9.72,17.7,12,18.46,15.18ZM19,14.4a11.9,11.9,0,0,0-3.85-6.58A7,7,0,0,0,10.3,6.35,5.42,5.42,0,0,0,6.48,8.6a3.81,3.81,0,0,0-.72,3.2l0,.13a5.07,5.07,0,0,1-.68,0,4.73,4.73,0,0,1-.65,0,2.38,2.38,0,0,1,0-.38A8,8,0,0,1,5.56,7.8a6.05,6.05,0,0,1,5.89-2.51,9.21,9.21,0,0,1,5.72,2.93A12.15,12.15,0,0,1,19.93,14,6.31,6.31,0,0,1,19,14.4Zm1.57-.8c-1.13-5.11-4.43-8.44-9-9A7.09,7.09,0,0,0,7,5.48a6,6,0,0,0-2.05,2,8.84,8.84,0,0,0-1.21,4.09v.26A3.46,3.46,0,0,1,2.29,11c1-4,2.43-5.58,4.3-6.62a9.54,9.54,0,0,1,5.7-.75,11,11,0,0,1,7.47,4.93,1.21,1.21,0,0,0,.2.19c1.37.38,1.6,2.37,1.6,2.37A2.31,2.31,0,0,1,20.57,13.6Z"
          fill="#fff"
        />
        <path
          d="
            M3,6.69s1.1-.93.94.51L5.36,5.56s-1.59,1-1.07-.77Z
            M11.36,2.67s1.36.43.06,1.05l2.17.39s-1.71-.81.09-1.32Z
            M17.74,5s.79,1.2-.62.86l1.45,1.67s-.83-1.7.9-1Z
            M18.17,11.29s.12,1.42-1,.45l.47,2.17s.1-1.9,1.27-.43Z
            M12.7,6.48s1.2.77-.21,1l2,.94S13,7.24,14.91,7.2Z
            M15.15,13.55s.1,1.43-1,.44l.44,2.17s.12-1.9,1.26-.42Z
            M12.64,11.14s-1.27-.69.14-1.05l-2.06-.81s1.53,1.13-.33,1.29Z
            M6.28,8.57s1.18-.82.88.6L8.79,7.68s-1.68.87-1-.87Z
            "
          fill="currentColor"
        />
        {/* <path
          d="M3,6.69s1.1-.93.94.51L5.36,5.56s-1.59,1-1.07-.77Z"
          fill="currentColor"
        />
        <path
          d="M11.36,2.67s1.36.43.06,1.05l2.17.39s-1.71-.81.09-1.32Z"
          fill="currentColor"
        />
        <path
          d="M17.74,5s.79,1.2-.62.86l1.45,1.67s-.83-1.7.9-1Z"
          fill="currentColor"
        />
        <path
          d="M18.17,11.29s.12,1.42-1,.45l.47,2.17s.1-1.9,1.27-.43Z"
          fill="currentColor"
        />
        <path
          d="M12.7,6.48s1.2.77-.21,1l2,.94S13,7.24,14.91,7.2Z"
          fill="currentColor"
        />
        <path
          d="M15.15,13.55s.1,1.43-1,.44l.44,2.17s.12-1.9,1.26-.42Z"
          fill="currentColor"
        />
        <path
          d="M12.64,11.14s-1.27-.69.14-1.05l-2.06-.81s1.53,1.13-.33,1.29Z"
          fill="currentColor"
        />
        <path
          d="M6.28,8.57s1.18-.82.88.6L8.79,7.68s-1.68.87-1-.87Z"
          fill="currentColor"
        /> */}
      </g>
    ),
  },
  logoInverted: {
    viewBox: "0 0 23 18.36",
    icon: (
      <g id="Layer_1-2-2" data-name="Layer 1-2">
        <g id="WqTwJY.tif">
          <path
            d="M7.54,12.49a8.82,8.82,0,0,1-2.7.34,4.41,4.41,0,0,1-3.41-1.54,4.23,4.23,0,0,1-.65-4.2,9.05,9.05,0,0,1,6-6A11.25,11.25,0,0,1,13,.78a3.9,3.9,0,0,1,2.25,1.37.46.46,0,0,0,.34.12,5.66,5.66,0,0,1,2.34.33,4.34,4.34,0,0,1,2.69,3.32A14.29,14.29,0,0,1,20.87,8a.53.53,0,0,0,.21.42,3.84,3.84,0,0,1,1.33,2.44,3.21,3.21,0,0,1-1.61,3.68,11.39,11.39,0,0,1-1.26.63c-.09,0-.2.13-.21.21a3.46,3.46,0,0,1-4.4,2.35,7,7,0,0,1-3-1.79c-.59-.57-1.09-1.23-1.65-1.84a.44.44,0,0,0-.31-.17,2.48,2.48,0,0,1-2.39-1.33Z"
            fill="#fff"
            stroke="currentColor"
            strokeMiterlimit="10"
          />
        </g>
        <path
          d="M22.28,11a3.94,3.94,0,0,0-1.56-2.69c0-.19,0-.41,0-.65a6.71,6.71,0,0,0-.84-3.27,4.32,4.32,0,0,0-3.93-2,5.31,5.31,0,0,0-.68,0,3.18,3.18,0,0,0-.63-.69A6,6,0,0,0,10.77.6,16,16,0,0,0,8.7.76,6.6,6.6,0,0,0,8,.89,9.63,9.63,0,0,0,2.13,4.61,8.48,8.48,0,0,0,.86,7.12a4.85,4.85,0,0,0-.17,2.3,4,4,0,0,0,.42,1.16v0a3.74,3.74,0,0,0,.68.9,4.06,4.06,0,0,0,1.73,1,6.09,6.09,0,0,0,.85.17,5.85,5.85,0,0,0,.73,0,6.51,6.51,0,0,0,.75,0,7,7,0,0,0,.78-.11c.32-.06.64-.14,1-.23A2.58,2.58,0,0,0,8,13a2.31,2.31,0,0,0,1.6.77h.21l.38,0a12.84,12.84,0,0,0,1.09,1.37,10.3,10.3,0,0,0,1.5,1.37,6.86,6.86,0,0,0,.88.56,5.62,5.62,0,0,0,1,.44,5.19,5.19,0,0,0,.87.19,3.69,3.69,0,0,0,.58,0h.23a3.9,3.9,0,0,0,.46-.12,3.41,3.41,0,0,0,.86-.36,3,3,0,0,0,1.46-1.85v0a2.21,2.21,0,0,0,.05-.25h0a7,7,0,0,0,1-.44,4.79,4.79,0,0,0,.75-.48A3,3,0,0,0,22.27,11M8.12,1.59c.22-.05.45-.09.68-.12a16.33,16.33,0,0,1,2-.15c3.67,0,4.07,1.83,4.07,1.83A8.3,8.3,0,0,1,16,3.06C19.41,3.06,20,6,20,7.64A11.56,11.56,0,0,0,12.41,2.9a10.3,10.3,0,0,0-6.15.83c-2,1.09-3.45,2.67-4.51,6.52a3.51,3.51,0,0,1-.36-1C1,7.14,3.11,2.64,8.12,1.59ZM10.35,13h0ZM14,16.4a9.58,9.58,0,0,0-1-3.42,2.91,2.91,0,0,0-1.74-1.48.37.37,0,0,0-.44.27.36.36,0,0,0,.27.44,2.15,2.15,0,0,1,1.28,1.13,7.84,7.84,0,0,1,.81,2.55,9.46,9.46,0,0,1-1.4-1.28A5.69,5.69,0,0,0,11,13.37l-.26-.31-.15-.16c-.63-.63-1.11-1.35-.4-2.16a1,1,0,0,1,.88-.38,3.77,3.77,0,0,1,2.5,1.81,5.9,5.9,0,0,1,.89,2,18.55,18.55,0,0,1,.51,2.57A5.41,5.41,0,0,1,14,16.4Zm2.2.58h-.09a4,4,0,0,1-.49,0A17.89,17.89,0,0,0,15.12,14a6.58,6.58,0,0,0-1-2.28,4.37,4.37,0,0,0-3-2.11,1.76,1.76,0,0,0-1.47.63A2,2,0,0,0,9.67,13a1.56,1.56,0,0,1-1.12-.52,4.38,4.38,0,0,1-.35-.91,2.75,2.75,0,0,1,1.3-2.5,3.06,3.06,0,0,1,3.2,0c1.78,1,3.85,3.54,3.93,7.76A2.5,2.5,0,0,1,16.24,17Zm2.22-1.8a2.27,2.27,0,0,1-1.11,1.41C17.18,12.21,15,9.5,13,8.48a3.76,3.76,0,0,0-3.94,0,3.48,3.48,0,0,0-1.62,3.11,8.08,8.08,0,0,1-1,.24,1.66,1.66,0,0,1-.06-.21A3.16,3.16,0,0,1,7.05,9a4.67,4.67,0,0,1,3.29-1.95A6.35,6.35,0,0,1,14.7,8.39C16.44,9.72,17.7,12,18.46,15.18ZM19,14.4a11.9,11.9,0,0,0-3.85-6.58A7,7,0,0,0,10.3,6.35,5.42,5.42,0,0,0,6.48,8.6a3.81,3.81,0,0,0-.72,3.2l0,.13a5.07,5.07,0,0,1-.68,0,4.73,4.73,0,0,1-.65,0,2.38,2.38,0,0,1,0-.38A8,8,0,0,1,5.56,7.8a6.05,6.05,0,0,1,5.89-2.51,9.21,9.21,0,0,1,5.72,2.93A12.15,12.15,0,0,1,19.93,14,6.31,6.31,0,0,1,19,14.4Zm1.57-.8c-1.13-5.11-4.43-8.44-9-9A7.09,7.09,0,0,0,7,5.48a6,6,0,0,0-2.05,2,8.84,8.84,0,0,0-1.21,4.09v.26A3.46,3.46,0,0,1,2.29,11c1-4,2.43-5.58,4.3-6.62a9.54,9.54,0,0,1,5.7-.75,11,11,0,0,1,7.47,4.93,1.21,1.21,0,0,0,.2.19c1.37.38,1.6,2.37,1.6,2.37A2.31,2.31,0,0,1,20.57,13.6Z"
          fill="currentColor"
        />
        <path
          d="M3,6.69s1.1-.93.94.51L5.36,5.56s-1.59,1-1.07-.77Z"
          fill="#fff"
        />
        <path
          d="M11.36,2.67s1.36.43.06,1.05l2.17.39s-1.71-.81.09-1.32Z"
          fill="#fff"
        />
        <path d="M17.74,5s.79,1.2-.62.86l1.45,1.67s-.83-1.7.9-1Z" fill="#fff" />
        <path
          d="M18.17,11.29s.12,1.42-1,.45l.47,2.17s.1-1.9,1.27-.43Z"
          fill="#fff"
        />
        <path
          d="M12.7,6.48s1.2.77-.21,1l2,.94S13,7.24,14.91,7.2Z"
          fill="#fff"
        />
        <path
          d="M15.15,13.55s.1,1.43-1,.44l.44,2.17s.12-1.9,1.26-.42Z"
          fill="#fff"
        />
        <path
          d="M12.64,11.14s-1.27-.69.14-1.05l-2.06-.81s1.53,1.13-.33,1.29Z"
          fill="#fff"
        />
        <path
          d="M6.28,8.57s1.18-.82.88.6L8.79,7.68s-1.68.87-1-.87Z"
          fill="#fff"
        />
      </g>
    ),
  },
  edlink: {
    viewBox: "0 0 1914.008 401",
    icon: (
      <>
        <path
          fill="#006AFF"
          d="M529.803,200.5L345.955,16.652l-70.711,70.71l-70.71-70.71L20.686,200.5l183.848,183.848l70.71-70.711
	l70.711,70.711L529.803,200.5z M204.534,313.637L91.396,200.5L204.534,87.363l35.355,35.356L162.107,200.5l77.782,77.782
	L204.534,313.637z M345.955,87.363L459.092,200.5L345.955,313.637L232.818,200.5L345.955,87.363z"
        />

        <g enableBackground="new    ">
          <path
            fill="#012649"
            d="M830.554,104.764v33.734H737.32v42.5h78.094v33.469H737.32v47.281h93.234v33.734h-131.75V104.764H830.554z"
          />
          <path
            fill="#012649"
            d="M910.244,104.764h65.609c60.031,0,96.688,37.188,96.688,95.359s-36.656,95.359-96.688,95.359h-65.609
      V104.764z M975.853,262.014c36.922,0,58.172-24.438,58.172-61.891c0-37.719-21.25-61.891-58.438-61.891h-27.094v123.781H975.853z"
          />
          <path
            fill="#012649"
            d="M1149.578,104.764h39.047v156.984h87.656v33.734h-126.703V104.764z"
          />
          <path
            fill="#012649"
            d="M1388.909,295.482h-39.047V104.764h39.047V295.482z"
          />
          <path
            fill="#012649"
            d="M1635.675,295.482h-34l-89.25-131.484v131.484h-37.453V104.764h39.578l83.672,125.109V104.764h37.453
      V295.482z"
          />
          <path
            fill="#012649"
            d="M1761.053,191.357l73.578-86.594h45.688l-71.453,81.547l75.969,109.172h-45.688l-56.047-79.688
      l-22.047,24.969v54.719h-39.047V104.764h39.047V191.357z"
          />
        </g>
      </>
    ),
  },
  visualAbstractReasoning: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M79 1691 l-29 -29 0 -642 c0 -550 2 -647 15 -674 31 -65 -27 -61 938
            -64 l878 -2 30 29 c26 26 29 36 29 91 0 51 -4 65 -25 85 l-24 25 -805 0 -806
            0 -2 581 -3 581 -28 24 c-22 19 -39 24 -83 24 -48 0 -60 -4 -85 -29z"
        />
        <path
          d="M1320 1589 c-89 -36 -78 -125 24 -201 25 -18 45 -35 46 -38 0 -3 -66
            -70 -146 -150 l-145 -145 -133 137 c-146 151 -185 177 -240 158 -35 -11 -278
            -251 -302 -298 -9 -17 -9 -32 -2 -53 13 -38 92 -109 121 -109 28 0 42 13 131
            118 l70 83 160 -159 c102 -101 171 -162 189 -166 49 -12 93 22 281 216 l183
            189 47 -56 c74 -86 144 -111 189 -66 21 21 22 31 25 251 l3 229 -30 33 -29 33
            -209 2 c-123 1 -218 -2 -233 -8z"
        />
      </g>
    ),
  },
  attention: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M821 1939 c-29 -5 -95 -23 -144 -40 -314 -105 -542 -364 -613 -694
            -20 -95 -20 -299 1 -400 75 -361 332 -629 694 -721 139 -36 334 -36 475 0 354
            91 607 355 687 717 27 122 23 323 -7 408 -11 30 -24 56 -30 58 -14 5 -162
            -133 -179 -168 -9 -17 -15 -56 -15 -98 0 -108 -25 -216 -71 -311 -34 -70 -58
            -101 -133 -175 -101 -99 -169 -144 -274 -181 -190 -66 -378 -50 -565 48 -87
            45 -221 182 -269 273 -59 114 -79 187 -85 311 -9 182 41 338 152 477 122 153
            348 257 559 257 41 0 82 3 91 7 18 6 178 194 171 200 -30 30 -335 52 -445 32z"
        />
        <path
          d="M1378 1843 c-149 -141 -162 -160 -163 -232 0 -40 7 -73 24 -108 15
            -32 21 -60 18 -75 -4 -13 -72 -89 -153 -168 -173 -172 -204 -210 -204 -257 0
            -48 45 -93 93 -93 48 0 92 35 232 184 66 70 137 136 157 146 45 24 96 25 146
            4 75 -33 102 -35 141 -9 39 25 227 214 255 255 9 13 16 41 16 62 0 44 -20 61
            -100 85 -116 33 -180 86 -200 165 -29 113 -55 148 -112 148 -35 0 -48 -9 -150
            -107z"
        />
        <path
          d="M861 1474 c-189 -51 -325 -206 -353 -404 -50 -340 272 -630 606 -544
            226 58 382 271 363 499 -5 62 -26 145 -36 144 -6 0 -166 -184 -250 -285 -77
            -95 -102 -109 -191 -109 -87 1 -138 22 -187 79 -41 46 -56 96 -51 165 6 80 32
            116 162 226 188 158 233 203 216 214 -46 31 -190 39 -279 15z"
        />
      </g>
    ),
  },
  flexibleThinking: {
    viewBox: "0 0 640 640",
    icon: (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 640 640"
      >
        <g id="bqvFoP.tif">
          <g fill="currentColor">
            <path
              d="M14.53,581.77c0-174.99,0-348.57,0-523.11c3.04-0.15,5.88-0.41,8.73-0.41c197.82-0.02,395.64,0.01,593.46-0.15
                c6.67-0.01,8.75,1.54,8.74,8.52c-0.2,168.93-0.2,337.86,0,506.79c0.01,7.01-2.13,8.51-8.76,8.5
                c-197.82-0.17-395.64-0.13-593.46-0.13C20.59,581.77,17.94,581.77,14.53,581.77z M105.22,71.5c0.02,0.48,0.03,0.97,0.05,1.45
                c8.16,3.92,16.09,8.45,24.53,11.62c16.95,6.36,31.46,16.78,45.64,27.39c9.72,7.27,18.1,16.59,26.08,25.85
                c8.42,9.78,16.78,19.95,23.1,31.12c7.56,13.35,13.19,27.82,19.15,42.02c5.77,13.72,11.04,27.66,16.28,41.59
                c4.08,10.86,7.62,21.93,11.7,32.79c3.19,8.49,7.26,16.66,10.21,25.22c4.63,13.45,8.76,27.08,12.8,40.72
                c0.61,2.06-0.2,4.67-0.81,6.9c-0.5,1.8-1.53,3.52-2.62,5.07c-3.25,4.62-5.76,11.62-10.17,13.2c-10.52,3.77-20.83,9.58-32.78,8.35
                c-3.67-0.38-7.42,0.16-11.13,0.05c-5-0.15-6.92,2.05-7.11,7.09c-0.76,20.14-2.19,40.25-2.72,60.39
                c-0.3,11.74-5.82,21.32-10.94,31.15c-9.56,18.38-29.07,21.1-45.79,26.56c-12.26,4.01-26.26,2.87-39.51,3.62
                c-8.64,0.49-17.33,0.08-25.99,0.43c-2.21,0.09-5.74,1.02-6.31,2.47c-2.24,5.76-4.35,11.8-5,17.89c-0.83,7.82-0.2,15.79-0.21,23.69
                c-0.02,11.31-0.02,11.33,11.16,11.33c142.37,0,284.74,0,427.11,0c1.73,0,3.75,0.52,5.13-0.18c1.78-0.9,4.31-2.77,4.34-4.26
                c0.26-13.58,0.39-27.18-0.16-40.74c-0.33-7.89-3.71-10.26-11.95-10.34c-12.63-0.12-25.25-0.2-37.88-0.38
                c-2.45-0.04-4.94-0.25-7.33-0.76c-9.88-2.12-19.89-3.84-29.52-6.76c-7.81-2.37-16.11-4.99-22.52-9.74
                c-13.62-10.1-20.67-24.98-22.32-41.48c-1.98-19.8-2.22-39.78-3.2-59.68c-0.08-1.73,0.54-3.79-0.21-5.11
                c-1.13-1.97-3.06-4.71-4.86-4.87c-12.3-1.11-24.53-0.36-36.8-4.49c-10.19-3.42-20.57-12.4-20.95-23.31
                c-0.42-12.05,2.03-23.1,7.31-34.34c7.84-16.69,13.23-34.53,19.68-51.87c5.53-14.86,10.91-29.78,16.68-44.54
                c6.21-15.87,12.5-31.72,19.32-47.34c6.88-15.77,16.91-29.68,28.46-42.32c7.18-7.86,14.89-15.43,23.28-21.94
                c11.18-8.68,22.79-17.04,35.09-24c12.6-7.13,26.26-12.39,39.46-18.48c-0.01-0.35-0.02-0.7-0.03-1.05
                C390.38,71.5,247.8,71.5,105.22,71.5z M574.32,255.56c1.97-21.42-15.72-31.97-33.91-32.16c-21.29-0.22-35.35,14.04-34.73,33.58
                c0.58,18.45,13.43,30.95,34.03,31.7C559.16,289.38,575.78,276.99,574.32,255.56z M96.59,223.33
                c-22.84,1.13-33.38,10.75-34.07,32.28c-0.64,20,14.19,34.27,34.02,33.87c19.36-0.39,33.7-14.04,33.43-32.4
                C129.64,234.69,118.7,224.78,96.59,223.33z"
            />
          </g>
        </g>
      </svg>
    ),
  },
  fasterSpeed: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M309 1917 c-32 -22 -34 -26 -37 -90 -3 -67 -3 -68 37 -107 28 -27 42
            -52 46 -77 36 -230 98 -368 215 -483 44 -44 106 -92 148 -115 39 -22 71 -42
            71 -45 0 -3 -31 -24 -69 -48 -218 -136 -315 -286 -355 -552 -4 -25 -17 -61
            -30 -80 -36 -54 -66 -139 -63 -179 3 -31 9 -39 48 -59 l45 -22 652 2 c644 3
            652 3 680 24 25 19 28 28 31 89 3 67 3 67 -37 104 -29 26 -41 47 -45 76 -28
            182 -62 280 -132 386 -55 83 -121 145 -224 210 l-81 52 53 30 c83 47 163 113
            214 174 82 101 145 253 160 383 5 47 14 70 34 94 34 39 62 123 58 173 -2 30
            -10 42 -37 60 l-34 23 -657 0 -657 0 -34 -23z m1078 -304 c-9 -144 -9 -144
            -444 -140 -263 2 -273 3 -294 23 -23 24 -38 83 -39 157 l0 47 391 0 392 0 -6
            -87z m-254 -828 c32 -16 77 -50 101 -75 41 -44 96 -135 96 -160 0 -7 -110 -10
            -330 -10 -257 0 -330 3 -330 13 1 50 96 174 167 218 91 56 199 61 296 14z"
        />
      </g>
    ),
  },
  visualSpatialReasoning: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M283 1931 c-220 -76 -290 -307 -187 -618 33 -99 138 -320 167 -353
            13 -14 29 -34 36 -45 8 -11 -3 -1 -24 23 l-38 43 -19 -28 c-65 -96 -127 -256
            -154 -401 -60 -319 99 -518 398 -499 110 6 206 35 401 118 108 47 154 73 217
            124 44 36 84 65 87 65 9 0 4 -4 -80 -69 -37 -29 -67 -56 -67 -60 0 -13 194
            -100 310 -139 99 -34 113 -36 235 -37 120 0 134 2 186 26 73 34 134 96 167
            167 37 83 43 225 12 346 -35 139 -135 371 -198 456 -14 19 -37 50 -50 68 -13
            17 -22 32 -19 32 3 0 27 -29 53 -65 l48 -65 18 28 c87 127 168 378 168 521 0
            179 -92 317 -242 362 -88 27 -227 23 -333 -11 -110 -34 -376 -150 -420 -184
            -22 -16 -46 -34 -52 -39 -7 -5 -13 -7 -13 -4 0 3 20 20 45 38 25 18 45 35 45
            39 0 9 -156 82 -244 115 -173 65 -348 83 -453 46z m227 -255 c36 -8 104 -30
            151 -49 l86 -34 46 34 c26 19 47 33 47 30 0 -2 -24 -23 -53 -45 -93 -70 -329
            -305 -347 -345 l-17 -38 -41 83 c-58 119 -87 271 -61 321 28 53 83 65 189 43z
            m370 10 c0 -2 -8 -10 -17 -17 -16 -13 -17 -12 -4 4 13 16 21 21 21 13z m758
            -16 c38 -23 52 -54 52 -116 0 -58 -42 -185 -81 -242 l-29 -44 32 -41 c50 -65
            51 -67 45 -67 -3 0 -26 28 -51 61 -46 63 -129 152 -254 272 -60 57 -76 67
            -109 68 -32 2 -33 3 -9 6 16 3 51 20 77 38 42 29 128 63 194 78 49 11 102 6
            133 -13z m-476 -135 c-24 -14 -57 -34 -73 -46 -16 -11 -29 -18 -29 -14 0 8
            121 85 134 85 6 0 -8 -11 -32 -25z m-144 -93 c-2 -4 56 -61 127 -126 141 -130
            225 -220 286 -306 21 -30 51 -71 66 -90 17 -23 13 -20 -15 10 l-42 45 -142
            -145 c-79 -80 -174 -171 -213 -201 -92 -73 -175 -132 -175 -125 0 3 18 17 39
            32 l39 25 -86 78 c-122 109 -266 262 -340 362 -35 46 -48 67 -30 46 l34 -38
            102 120 c99 116 178 192 290 279 55 43 64 48 60 34z m-554 -289 c9 -18 14 -33
            12 -33 -6 0 -36 55 -36 66 0 11 5 3 24 -33z m-124 -294 c15 -28 5 -23 -15 7
            -9 15 -12 23 -6 20 6 -4 16 -16 21 -27z m1205 -10 c9 -17 15 -33 13 -35 -3 -2
            -12 12 -21 31 -21 43 -13 47 8 4z m-1050 -190 c143 -153 220 -219 258 -220 27
            -2 28 -2 7 -6 -14 -3 -40 -16 -58 -30 -74 -56 -241 -105 -304 -90 -48 12 -79
            48 -85 97 -7 63 21 181 60 261 l34 67 -19 34 c-16 28 -16 29 -1 8 10 -14 59
            -68 108 -121z m1072 119 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
            m63 -113 c30 -64 60 -190 60 -249 0 -25 -9 -45 -29 -68 -27 -30 -34 -33 -88
            -32 -76 1 -151 19 -240 59 l-72 31 32 39 c18 22 48 53 67 69 70 59 182 182
            197 216 15 33 16 34 30 15 9 -11 28 -47 43 -80z m-730 -170 c0 -2 -10 -9 -22
            -15 -22 -11 -22 -10 -4 4 21 17 26 19 26 11z m349 -99 c-10 -9 -69 -36 -69
            -32 0 7 52 35 64 36 5 0 7 -2 5 -4z"
        />
        <path
          d="M940 1117 c-58 -29 -87 -118 -57 -177 38 -75 154 -93 208 -32 97 108
            -23 274 -151 209z"
        />
      </g>
    ),
  },
  verbalMemory: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M110 1947 c-13 -7 -35 -28 -47 -46 -23 -34 -23 -35 -23 -407 l0 -374
            960 0 960 0 -1 363 c0 253 -4 372 -12 396 -27 77 -101 95 -267 63 -194 -38
            -391 -55 -640 -55 -254 0 -391 10 -657 48 -194 28 -237 30 -273 12z m710 -373
            c91 -25 258 -23 364 5 44 12 89 21 100 21 49 -1 76 -49 79 -142 1 -48 -3 -61
            -23 -83 -45 -48 -97 -22 -107 54 l-6 41 -227 0 -228 0 -7 -42 c-12 -75 -58
            -100 -103 -58 -30 28 -35 55 -23 130 17 105 40 114 181 74z"
        />
        <path
          d="M42 556 c3 -428 4 -445 23 -466 45 -51 24 -50 935 -50 926 0 899 -2
            937 56 17 26 18 61 21 443 2 229 0 426 -3 438 l-5 23 -956 0 -955 0 3 -444z
            m1278 74 c29 -15 40 -50 40 -123 0 -74 -18 -107 -59 -107 -43 0 -62 21 -68 73
            l-6 47 -228 0 -228 0 -6 -37 c-11 -62 -14 -69 -39 -81 -56 -25 -102 36 -92
            122 9 69 26 99 62 111 44 14 596 10 624 -5z"
        />
      </g>
    ),
  },
  verbalReasoning: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M861 1903 c-54 -47 -624 -723 -647 -769 -36 -75 -42 -166 -15 -277
            20 -84 20 -89 4 -135 -27 -75 -23 -185 9 -248 49 -94 54 -97 520 -253 256 -86
            438 -141 454 -139 24 2 73 60 317 368 158 201 295 379 303 396 15 28 14 35 -5
            98 -25 81 -26 120 -5 206 9 36 17 110 18 164 2 85 -1 103 -16 118 -28 28 -80
            22 -98 -12 -6 -10 -14 -51 -20 -91 -6 -40 -19 -87 -29 -104 -10 -16 -114 -154
            -232 -305 -118 -152 -225 -290 -239 -308 l-25 -32 -399 129 c-259 84 -406 136
            -419 150 -32 31 -36 127 -7 164 32 40 63 36 287 -37 394 -128 485 -156 512
            -156 17 0 37 11 53 28 52 54 610 748 624 775 17 33 11 63 -17 77 -27 15 -845
            210 -879 210 -15 0 -37 -8 -49 -17z m281 -278 c114 -29 211 -56 217 -60 19
            -11 12 -30 -26 -74 l-37 -43 -55 6 c-31 3 -146 30 -256 58 -225 60 -230 63
            -175 130 48 57 35 58 332 -17z m529 -686 l12 -45 -254 -326 c-140 -180 -262
            -330 -272 -333 -28 -10 -776 242 -809 273 -31 28 -43 75 -34 125 14 77 -10 81
            433 -63 221 -71 411 -130 422 -130 11 0 26 3 35 6 9 3 111 129 228 280 116
            151 215 271 219 267 4 -4 13 -28 20 -54z"
        />
      </g>
    ),
  },
  visualMemory: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M706 1836 c-56 -21 -82 -51 -120 -141 l-33 -80 -180 -6 c-164 -5
            -184 -7 -229 -30 -39 -19 -54 -34 -74 -74 l-25 -50 0 -575 c0 -449 3 -583 13
            -612 16 -46 69 -94 119 -107 52 -15 1594 -15 1646 0 50 13 103 61 119 107 10
            29 13 163 13 612 l0 575 -25 50 c-20 40 -35 55 -75 75 -46 22 -63 25 -230 28
            l-182 4 -18 55 c-26 77 -68 139 -107 160 -29 16 -65 18 -303 20 -215 2 -278 0
            -309 -11z m375 -506 c212 -40 368 -231 369 -450 0 -269 -216 -474 -480 -457
            -135 8 -247 70 -332 182 -62 83 -83 152 -83 280 0 106 1 113 37 188 91 191
            289 294 489 257z"
        />
        <path
          d="M875 1180 c-74 -29 -120 -72 -157 -147 -29 -59 -33 -77 -33 -148 0
            -111 24 -175 89 -241 62 -61 129 -87 226 -87 131 0 233 61 287 171 24 50 28
            69 28 148 0 84 -3 96 -35 160 -41 79 -94 126 -172 149 -71 21 -171 18 -233 -5z"
        />
      </g>
    ),
  },
  visualMotorSpeed: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M1683 1766 c-33 -15 -441 -313 -713 -520 -157 -120 -266 -218 -341
            -309 l-48 -57 90 -128 c50 -70 96 -126 102 -124 67 18 297 143 422 230 184
            128 683 498 723 536 53 50 68 96 53 153 -14 52 -86 158 -134 196 -43 35 -106
            44 -154 23z"
        />
        <path
          d="M456 750 c-25 -27 -46 -53 -46 -59 0 -5 27 -46 61 -90 67 -89 87 -98
            139 -61 15 11 37 23 49 28 20 7 17 14 -56 120 -43 61 -83 112 -89 112 -6 0
            -32 -22 -58 -50z"
        />
        <path
          d="M1445 682 c-189 -88 -194 -347 -9 -438 106 -52 231 -15 301 89 76
            113 41 256 -81 331 -62 39 -151 46 -211 18z"
        />
        <path
          d="M245 565 l-79 -64 -33 20 c-41 26 -70 22 -96 -13 -27 -36 -17 -58 81
            -177 88 -108 99 -116 135 -107 41 10 62 49 50 91 l-11 34 79 52 c43 28 79 55
            79 60 0 11 -109 163 -118 166 -4 1 -43 -27 -87 -62z"
        />
      </g>
    ),
  },
  workingMemory: {
    viewBox: "0 0 200 200",
    icon: (
      <g
        transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
      >
        <path
          d="M377 1694 l-128 -124 -55 45 c-31 25 -59 45 -62 45 -4 0 -21 -9 -39
            -20 -40 -24 -67 -73 -54 -98 18 -33 198 -202 216 -202 19 0 344 320 365 359
            10 20 7 27 -38 72 -27 27 -55 49 -63 49 -8 -1 -72 -57 -142 -126z"
        />
        <path
          d="M803 1690 c-32 -13 -43 -41 -43 -112 0 -78 13 -97 71 -109 57 -11
            1001 -11 1058 0 60 12 71 30 71 116 0 119 51 110 -589 112 -303 1 -556 -2
            -568 -7z"
        />
        <path
          d="M380 1085 l-126 -125 -53 40 c-88 66 -112 64 -146 -9 -24 -54 -14
            -82 43 -127 26 -21 68 -60 93 -87 46 -48 47 -48 75 -34 16 8 105 92 197 186
            l168 171 -22 32 c-38 56 -62 78 -82 78 -12 0 -70 -49 -147 -125z"
        />
        <path
          d="M804 1078 c-12 -5 -27 -21 -33 -34 -14 -32 -14 -119 0 -146 25 -47
            44 -48 591 -47 282 1 524 4 537 8 40 11 65 54 64 109 -1 68 -10 90 -43 107
            -25 13 -109 15 -562 14 -345 0 -541 -4 -554 -11z"
        />
        <path
          d="M200 524 c-45 -20 -68 -41 -91 -86 -43 -84 -7 -187 83 -234 35 -18
            111 -18 147 0 37 19 89 80 97 112 11 45 -2 112 -30 149 -52 67 -133 91 -206
            59z"
        />
        <path
          d="M805 469 c-36 -20 -45 -42 -45 -105 0 -52 4 -68 23 -90 l24 -27 552
            0 c540 0 552 0 572 20 27 26 38 81 29 133 -15 80 26 75 -588 77 -385 2 -553
            -1 -567 -8z"
        />
      </g>
    ),
  },
  books: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        version="1.1"
        id="Layer_1"
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 576 512"
      >
        <g>
          <path
            fill="currentColor"
            fillOpacity="80%"
            d="M96,0H32C14.3,0,0,14.3,0,32v64h128V32C128,14.3,113.7,0,96,0z M0,384h128V128H0V384z M0,480
		c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32v-64H0V480z M513.6,462.2L401.1,42.7l-60.3,16.1l112.4,418.8
		c0.1,0.4,0.2,0.8,0.3,1.2l60.3-16.1C513.7,462.5,513.7,462.4,513.6,462.2z M160,480c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32
		v-64H160V480z M256,0h-64c-17.7,0-32,14.3-32,32v64h124.8l-8-29.7c-2.8-10.5,1.7-21.6,11.2-27V32C288,14.3,273.7,0,256,0z M160,384
		h128V128H160V384z"
          />
          <path
            fill="currentColor"
            d="M0,416h128v-32H0V416z M0,128h128V96H0V128z M575.2,445.6L460.4,17.8C457,5,444-2.6,431.2,0.8h-0.1L415.7,5
		c-12.8,3.5-20.3,16.6-16.9,29.4l114.8,427.9c3.4,12.7,16.4,20.4,29.2,17h0.1l15.4-4.2C571,471.5,578.6,458.4,575.2,445.6
		L575.2,445.6z M160,416h128v-32H160V416z M338.4,49.8C335,37,322,29.4,309.2,32.8h-0.1L293.7,37c-12.8,3.5-20.3,16.6-16.9,29.4
		l8,29.7H160v32h128v-20l103.6,386.2c3.4,12.7,16.4,20.4,29.2,17h0.1l15.4-4.2c12.7-3.5,20.3-16.6,16.9-29.3L338.4,49.8z"
          />
        </g>
      </svg>
    ),
  },
  booksColored: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 17.93 15.95"
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#3680c3"
            d="m8.98,1.19c.71-.2,1.42-.38,1.68.63.23.22.33.5.41.8,1,3.79,2.02,7.58,3.04,11.37.07.26.15.54.04.81.06.82-.51,1.05-1.14,1.12-.68.08-.77-.47-.9-.96-.98-3.67-1.98-7.33-2.96-11,0-.05-.04-.09-.06-.14-.04.05-.08.1-.12.15-.8.52-1.7.21-2.55.27-.48.03-.99.11-1.4-.27v-.96c.31-.32.72-.24,1.1-.26.74-.04,1.49.08,2.23-.09.31-.47-.16-1.26.65-1.48"
          />
          <path
            fill="#44c8f5"
            d="m3.98,3.97v8.01c-1.32.39-2.64.39-3.95,0V3.97c1.32-.39,2.64-.39,3.95,0"
          />
          <path
            fill="#44c8f5"
            d="m5.01,3.97h3.96v8.01c-1.32.39-2.64.39-3.95,0V3.97h0Z"
          />
          <path
            fill="#44c8f5"
            d="m12.45,1.32c0-.44-.08-.89.46-1.13.85-.39,1.28-.2,1.53.72.68,2.5,1.34,5.01,2.01,7.52.45,1.68.89,3.36,1.34,5.03.14.5.32,1-.31,1.28-.55.24-1.12.38-1.51-.3-.28-.22-.35-.55-.43-.87-.95-3.66-1.96-7.3-2.94-10.95-.11-.42-.31-.84-.15-1.29"
          />
          <path
            fill="#44c8f5"
            d="m12.45,1.32c.94,3.44,1.88,6.88,2.81,10.33.25.93.47,1.86.71,2.79-.61.12-1.21.24-1.82.36-.77-2.81-1.55-5.62-2.32-8.43-.41-1.51-.78-3.03-1.18-4.55.6-.16,1.19-.33,1.79-.49"
          />
          <path
            fill="#44c8f5"
            d="m.03,3.01C.03,2.41.01,1.8.02,1.2.02.43.42.02,1.19.01c2.7-.02,2.9-.24,2.82,2.67,0,.11,0,.22,0,.33-1.32.39-2.64.39-3.95,0"
          />
          <path
            fill="#44c8f5"
            d="m3.98,12.94c0,.6.02,1.21,0,1.81,0,.76-.39,1.18-1.17,1.19-2.74.02-2.89.21-2.81-2.67,0-.11,0-.22,0-.33,1.32-.39,2.64-.39,3.95,0"
          />
          <path
            fill="#44c8f5"
            d="m8.97,12.94c0,.6.02,1.21,0,1.81,0,.76-.4,1.18-1.17,1.19-2.74.02-2.89.21-2.82-2.67,0-.11,0-.22,0-.33,1.32-.39,2.64-.39,3.95,0"
          />
          <path
            fill="#44c8f5"
            d="m8.98,1.19c-.69.51-.12,1.16-.18,1.82h-3.79c0-.55-.02-1.1,0-1.65C5.01.36,5.35.02,6.33,0h1.32c.82-.02,1.31.32,1.34,1.19"
          />
          <path fill="#3680c3" d="m.03,3.01h3.95v.96H.03v-.96Z" />
          <rect fill="#3680c3" x=".03" y="11.98" width="3.95" height=".96" />
          <rect fill="#3680c3" y="11.98" width="3.95" height=".96" />
        </g>
      </svg>
    ),
  },
  functionIcon: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 640 640"
      >
        <g>
          <path
            fill="currentColor"
            d="M211.14,64.43c6.46,1.51,10.78,5.31,12.63,11.77c0.47,1.63,0.56,3.31,0.56,4.99
		c0.02,15.35,0.01,30.71,0.01,46.06c0,3.33-0.56,6.54-2.42,9.38c-3.2,4.91-7.69,7.55-13.61,7.56c-15.51,0.01-31.03,0.02-46.54-0.01
		c-5.94-0.01-11.4,1.41-16.12,5.14c-6.23,4.94-9.32,11.46-9.34,19.37c-0.05,17.35-0.01,34.7-0.01,52.06c0,3.04-0.01,6.08,0,9.12
		c0.01,2.22,0.02,2.24,2.22,2.24c12.08,0.01,24.15,0,36.23,0c2.16,0,4.31,0.14,6.4,0.8c6.5,2.05,11.13,8.11,11.15,14.93
		c0.06,16.23,0.15,32.47-0.03,48.7c-0.11,10.13-8.83,15.71-15.87,15.63c-12.47-0.16-24.95-0.05-37.43-0.04
		c-2.96,0-2.67-0.26-2.67,2.73c0,41.74-0.08,83.48,0.02,125.22c0.11,47.74-32.73,89.8-79.59,101.16
		c-7.96,1.93-16.05,2.81-24.23,2.88c-5.04,0.04-10.08,0.01-15.11,0.01c-8.37-0.01-13.85-3.97-16.52-11.93
		c-0.18-0.52-0.28-1.1-0.88-1.34c0-17.43,0-34.86,0-52.3c0.71-0.92,0.4-2,0.5-3.03c1.36-6.5,8.01-11.93,14.95-12.06
		c5.52-0.11,11.03,0.04,16.55-0.04c11.06-0.16,20.05-7.19,22.85-17.78c0.43-1.64,0.57-3.3,0.57-4.99c0-41.41,0-82.83-0.01-124.24
		c0-3.56-0.07-3.62-3.61-3.62c-11.75-0.01-23.51,0.01-35.26-0.01c-7.75-0.01-13.42-4.09-15.98-11.41c-0.11-0.63-0.04-1.28-0.25-1.89
		c-0.13-0.44,0.07-0.95-0.31-1.33c0-17.59,0-35.18,0-52.78c0.85-4.6,3.04-8.34,6.98-10.98c3.53-2.37,7.51-3.09,11.64-3.11
		c11.11-0.05,22.23-0.01,33.34-0.02c3.46,0,3.5-0.03,3.5-3.45c0-19.99-0.26-39.98,0.07-59.96c0.44-26.31,9.15-49.61,26.8-69.35
		c16.27-18.2,36.53-29.19,60.5-33.47c3.39-0.61,6.83-0.64,10.25-0.77c0.98,0,1.96,0,2.94,0c0.88,0,1.76,0,2.65,0
		c16.63,0,33.25,0,49.88,0c0.44,0,0.88,0,1.33,0C210.3,64.26,210.74,64.19,211.14,64.43z"
          />
          <path
            fill="currentColor"
            fillOpacity="80%"
            d="M301.81,575.93c-1.6,0-3.21,0-4.81,0c-2.95-0.56-5.64-1.74-7.99-3.6c-2.1-1.66-3.43-3.98-4.98-6.1
		c-6.19-8.44-12.01-17.12-17.3-26.15c-5.89-10.07-11.27-20.41-15.98-31.09c-4.33-9.79-8.21-19.75-11.51-29.93
		c-3.93-12.14-7.1-24.48-9.48-37.03c-1.26-6.65-2.4-13.32-3.2-20.03c-0.72-6.01-1.29-12.03-1.66-18.08
		c-0.26-4.31-0.14-8.62-0.47-12.91c-0.24-3.11-0.48-6.22-0.27-9.32c0.34-5.02,0.15-10.06,0.49-15.07c0.46-6.83,1.05-13.66,1.9-20.45
		c1.45-11.54,3.52-22.97,6.26-34.28c3.69-15.22,8.5-30.08,14.44-44.57c2.24-5.46,4.67-10.85,7.23-16.18
		c6.56-13.72,14.14-26.83,22.66-39.41c2.95-4.36,6-8.66,9.18-12.86c6.24-8.23,17.14-9,24.84-1.99c3.71,3.38,7.7,6.47,11.47,9.78
		c4.25,3.74,8.63,7.34,12.88,11.09c6.07,5.35,6.07,15.46,1.59,21.41c-7.54,10.04-14.15,20.67-20.05,31.76
		c-7.34,13.8-13.11,28.22-17.7,43.13c-2.81,9.15-5.01,18.45-6.64,27.88c-1.06,6.12-1.88,12.27-2.48,18.45
		c-0.5,5.16-0.73,10.33-1,15.51c-0.2,3.83-0.46,7.66-0.27,11.48c0.34,6.68,0.55,13.37,1.22,20.04c0.89,8.81,2.18,17.53,3.96,26.19
		c1.35,6.56,2.97,13.05,4.86,19.48c2.94,9.96,6.54,19.69,10.73,29.19c4.35,9.88,9.41,19.4,15.07,28.59
		c3.85,6.26,7.99,12.32,12.33,18.25c3.5,4.8,4.05,10.1,2.2,15.7c-0.77,2.34-2.15,4.33-3.96,5.9c-4.69,4.09-9.5,8.04-14.25,12.06
		c-3.29,2.78-6.67,5.46-9.82,8.4C308.55,573.7,305.43,575.24,301.81,575.93z"
          />
          <path
            fill="currentColor"
            fillOpacity="80%"
            d="M639.63,394.1c0.01,1.44,0.02,2.88,0.03,4.32c0.08,5.91-0.48,11.8-1.12,17.66c-0.8,7.27-1.8,14.52-3.12,21.74
		c-1.48,8.16-3.2,16.25-5.3,24.27c-3.47,13.3-7.85,26.29-13.06,39c-3.58,8.73-7.52,17.28-11.91,25.63
		c-7.93,15.08-17.03,29.43-27.32,43.01c-2.56,3.38-6.01,5.43-10.19,6.22c-1.76,0-3.53,0-5.29,0c-3.86-0.8-7.03-2.75-9.99-5.35
		c-5.68-5.01-11.6-9.75-17.33-14.7c-2.23-1.93-4.48-3.84-6.62-5.88c-4.98-4.76-5.95-13.45-2.01-19.41
		c3.6-5.46,7.58-10.67,11.07-16.21c6.82-10.83,12.86-22.06,17.93-33.82c5.9-13.66,10.51-27.73,13.86-42.22
		c1.54-6.67,2.79-13.4,3.7-20.19c0.9-6.63,1.48-13.28,1.98-19.96c0.61-8.23,0.55-16.46,0.24-24.66c-0.34-8.74-1.27-17.45-2.61-26.12
		c-2.18-14.22-5.58-28.12-10.21-41.73c-3.01-8.84-6.55-17.48-10.58-25.92c-5.86-12.28-12.72-23.96-20.5-35.12
		c-1.41-2.03-2.91-4-4.3-6.04c-5.26-7.7-3.35-17.11,3.74-22.57c3.72-2.87,7.21-6.05,10.79-9.1c4.44-3.77,8.71-7.76,13.33-11.29
		c8.51-6.49,18.42-3.24,23.02,2.91c7.51,10.05,14.54,20.42,20.81,31.28c8.23,14.27,15.34,29.09,21.25,44.48
		c5.3,13.8,9.5,27.93,12.77,42.33c1.67,7.37,3.03,14.81,4.13,22.3c0.89,6.07,1.61,12.15,2.19,18.25c0.39,4.12,0.8,8.26,0.65,12.42
		c-0.01,1.6-0.01,3.2-0.02,4.79c-0.01,1.6-0.01,3.21-0.02,4.81c0,3.37,0,6.73,0,10.1C639.62,390.9,639.62,392.5,639.63,394.1z"
          />
          <path
            fill="currentColor"
            d="M489.71,480.04c-4.34,0.02-7.82-1.38-10.82-4.02c-0.72-0.63-1.39-1.32-2.07-2
		c-14.25-14.25-28.5-28.5-42.75-42.74c-2.2-2.2-1.6-2.11-3.76,0.04c-14.43,14.41-28.85,28.82-43.25,43.25
		c-2.42,2.43-5.11,4.35-8.53,5.06c-5.44,1.13-10.44,0.14-14.46-3.77c-7.96-7.75-15.84-15.6-23.58-23.57
		c-5.64-5.8-5.71-15.05-0.45-21.23c0.67-0.79,1.42-1.52,2.15-2.25c14.13-14.14,28.27-28.27,42.41-42.41
		c0.28-0.28,0.57-0.56,0.85-0.85c1.51-1.53,1.64-1.27-0.02-2.92c-14.53-14.53-29.06-29.07-43.61-43.58
		c-2.37-2.36-4.31-4.94-5.07-8.25c-1.28-5.6-0.29-10.75,3.75-14.91c7.7-7.91,15.5-15.71,23.4-23.41c5.9-5.75,15.17-5.84,21.4-0.46
		c0.73,0.63,1.4,1.31,2.08,1.99c14.31,14.3,28.61,28.61,42.92,42.91c2.12,2.12,1.63,2.13,3.79-0.03
		c14.48-14.47,28.97-28.93,43.42-43.43c3.25-3.26,7.04-5.23,11.67-5.33c4.35-0.09,8.22,1.3,11.32,4.37
		c7.79,7.7,15.58,15.41,23.23,23.24c5.85,5.99,5.96,15.25,0.47,21.58c-0.63,0.72-1.32,1.39-2,2.07
		c-14.13,14.14-28.27,28.27-42.4,42.4c-0.23,0.23-0.45,0.45-0.68,0.68c-1.77,1.79-1.77,1.51,0.02,3.29
		c14.53,14.53,29.04,29.08,43.61,43.58c3.27,3.25,5.29,7.01,5.41,11.64c0.12,4.43-1.32,8.37-4.45,11.54
		c-7.65,7.73-15.34,15.42-23.07,23.07C497.57,478.65,493.77,480.13,489.71,480.04z"
          />
        </g>
      </svg>
    ),
  },
  fileUser: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 486.3 640"
      >
        <g>
          <path
            fill="currentColor"
            d="M470,188.3c-3-3-5.7-6.2-8.6-9.1c-49.9-50-99.9-99.9-149.8-149.8c-6.2-6.1-12.4-12.2-18.8-18.1
			C285.3,4.5,276.6,0.9,266.4,1C257.1,1.2,247.7,1,238.4,1C187.1,1,135.8,0.6,84.5,1.1C52.7,1.5,28.7,16.2,13.2,44.2
			C5.8,57.5,3.7,72,3.8,87c0.1,77.7,0.1,155.4,0.1,233.2c0,77.4,0,154.8,0,232.2c0,11.7,1.1,23.1,5.2,34.1
			c11.5,30.5,41.9,52.4,76.2,52.2c45.8-0.2,91.6,0,137.4,0c58,0,116.1-0.1,174.1,0.1c10.7,0,21.2-1.1,31.3-4.8
			c33.7-12.2,54.3-42.3,54.3-78.7c0.1-111.9,0-223.8,0.1-335.7C482.4,207.4,478.7,196.9,470,188.3z M283.5,33.7
			c55,55.1,110.4,110.5,165.9,166.1c-1.9,1-5.5,0.5-9,0.5c-41.9,0-83.8-0.1-125.7-0.3c-15.2-0.1-24.5-6.6-29.9-19.9
			c-1.1-2.8-1.6-5.6-1.6-8.5c0-45.1-0.1-90.3-0.1-135.4C283.2,35,283.5,33.7,283.5,33.7z M451.7,592c-11.8,17.7-29.1,26.2-49.9,26.5
			c-28.4,0.5-56.8-0.2-85.1-0.2c-75.8,0.1-151.6,0.2-227.4,0.4c-15.2,0-29.3-3.3-41.7-12.5c-15.2-11.3-23-26.9-23.4-45.5
			c-0.7-30.6-0.3-61.3-0.3-91.9c0-50,0-100,0-150c0-77.1,0.1-154.2-0.1-231.2c0-12.5,1.7-24.4,7.5-35.4
			c10.3-19.2,27.2-28.5,48.2-30.9c7.3-0.9,14.8-0.4,22.2-0.4c49.7,0,99.3,0,149,0c2.3,0,4.5,0.2,6.8,0c4.4-0.4,5.7,1.8,5.4,5.7
			c-0.2,2.2,0,4.5,0,6.8c0,45.8,0.7,91.6-0.2,137.4c-0.5,22.8,23.2,49.5,48.5,49.4c44.8-0.2,89.7,0,134.5,0c16.6,0,16.6,0,16.6,16.8
			c0,104.8-0.1,209.6,0,314.5C462.3,566,459.8,579.8,451.7,592z"
          />
          <path
            fill="currentColor"
            d="M382.4,537.2c-1.2-26.2-9.7-49.8-28.5-68.7c-19.1-19.2-42.8-28.3-69.4-29c-24.8-0.7-49.6-0.1-74.5-0.2
			c-9.7,0-19.2,0.9-28.7,2.8c-49.3,9.9-78.2,53.1-77.5,98.1c0.1,7.5,3.8,12.5,10.1,16.2c4.5,2.7,9.2,2.5,14.1,2.5
			c38.4,0,76.7,0,115.1,0c19.7,0,39.3,0,59,0c19.7,0,39.3,0.1,59-0.1C374.7,558.8,383,550.7,382.4,537.2z M354.5,539
			c-37.4,0.1-74.8,0-112.1,0c0,0,0,0,0,0c-36.4,0-72.8,0-109.2,0c-9.7,0-10.4-0.9-8.9-10.5c6.2-39.8,39.1-68.6,79.4-69.2
			c26.1-0.3,52.2-0.4,78.3,0c41.4,0.5,75.1,30.8,80.2,71.7C363.1,538.4,362.6,539,354.5,539z"
          />
          <path
            fill="currentColor"
            d="M242.7,240.2c-42.9-0.3-79.1,36.2-79.2,79.4c-0.6,40.7,33.5,80,79.8,79.7c43.5-0.3,79.2-35.2,79.2-79.2
			C322.5,274.1,285.4,240.5,242.7,240.2z M243,379.1c-34.1,0.2-58.6-25.8-59.4-59.2c0.7-33.5,24.9-59.4,59.3-59.3
			c35.5,0.2,59.3,25.1,59.3,59.1C302.2,354.4,277.2,379,243,379.1z"
          />
        </g>
      </svg>
    ),
  },
  fileChartColumnThin: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 486.3 640"
      >
        <g>
          <path
            fill="currentColor"
            d="M263.1,419.6c0,38.7,0.1,77.3,0,116c0,14.1-5.2,20.6-17.2,22.4c-9.8,1.5-19.1-4.7-21.1-14.4
				c-0.7-3.5-1.2-7.1-1.2-10.6c-0.1-75.7-0.1-151.3,0-227c0-14,4.6-21.6,14.3-24.1c13-3.4,23.7,3.6,25,16.8
				c0.6,6.8,0.3,13.8,0.3,20.7C263.1,352.8,263.1,386.2,263.1,419.6z"
          />
          <path
            fill="currentColor"
            d="M383.6,459.4c0,25.7,0.2,51.4-0.1,77c-0.1,16.4-11.8,25.8-26,20.2c-4.9-1.9-8.8-7.6-11.9-12.4
				c-1.8-2.7-1.5-6.9-1.5-10.5c-0.1-49.7-0.1-99.4,0-149.1c0-12.3,4.5-20.3,12.6-23c14.2-4.9,26.5,3.5,26.8,19
				c0.4,19,0.1,38.1,0.1,57.1C383.6,445.1,383.6,452.2,383.6,459.4z"
          />
          <path
            fill="currentColor"
            d="M142.4,499.2c0,13.2,0.2,26.5-0.1,39.7c-0.2,7.5-2.8,14.1-10.6,17.3c-7.5,3.1-15.6,3.4-21-2.5
				c-4.1-4.5-7.2-11.4-7.4-17.4c-0.8-24.8-0.7-49.7-0.2-74.5c0.3-16.4,11.8-24.9,26.4-20.6c8.1,2.4,12.7,8.8,12.9,19.1
				C142.7,473.2,142.5,486.2,142.4,499.2C142.5,499.2,142.4,499.2,142.4,499.2z"
          />
          <path
            fill="currentColor"
            d="M469.4,186.6C411.7,129.3,354,72,296.4,14.5c-9-8.9-19.5-13.4-32.1-13.4c-59.8,0-119.7-0.4-179.5,0.2
				c-26.1,0.3-48.6,9.8-65.1,31.3C7.3,48.8,2.1,67,2.1,86.8C2,164.6,2,242.4,2,320.1c0,78.1-0.1,156.1,0,234.2
				C2.2,603,37.4,638.9,85.7,639c104.7,0.2,209.3,0.2,314,0c48.3-0.1,83.3-34.8,83.4-82.7c0.2-112.1,0-224.2,0.2-336.3
				C483.3,206.6,478.7,195.9,469.4,186.6z M282.7,32.7c56.1,55.8,112.5,111.9,168.8,167.9c-1.3,0.7-4.1-0.1-6.7-0.1
				c-41.7,0.1-83.4,0.1-125.1,0c-25,0-36.9-11.7-37-36.4C282.7,119.9,282.7,75.7,282.7,32.7z M463.1,554.7
				c0,39.3-25.2,64.4-64.7,64.4c-103.8,0.1-207.6,0.1-311.4,0c-39,0-64.8-25.7-64.9-64.6c-0.1-78.3,0-156.6,0-235
				c0-77.5,0-155,0-232.5c0-10.6,1.7-20.9,6.1-30.6c10.6-23.7,30.4-34.6,55.1-35c57.9-0.9,115.8-0.2,173.7-0.4
				c6.2,0,5.8,2.9,5.8,7.1c-0.1,45.9-0.1,91.9,0,137.8c0,15.2,4,28.8,15.4,39.8c10.6,10.3,22.9,14.9,37.6,14.9
				c46.5-0.2,93,0.1,139.4-0.2c6.5,0,8.2,1.5,8.2,8.1C463,337.1,463.1,445.9,463.1,554.7z"
          />
        </g>
      </svg>
    ),
  },
  fileChartColumn: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 486.3 640"
      >
        <g>
          <path
            fill="currentColor"
            d="M2.5,320c0-77.3-0.1-154.6,0-232c0-19.5,4.8-37.5,16.8-53.5C36,12.3,59,2.7,85.8,2.4
				c60.8-0.6,121.7-0.3,182.5-0.1c23.3,0.1,43.5,7.9,60.2,24.5c43.1,42.9,86.4,85.6,129.6,128.3c17.6,17.4,26.3,38.1,26.2,63.1
				c-0.4,112.1-0.1,224.2-0.2,336.3c0,40.6-23.3,70.9-62.1,80.6c-7.5,1.9-15.4,2.7-23.2,2.7c-103.5,0.2-207.1,0.2-310.6,0.1
				c-50.4,0-85.7-35-85.7-85.2C2.4,475.2,2.5,397.6,2.5,320z M243.6,41.5c-3.9,0-6.4,0-8.9,0c-49.4,0-98.8,0-148.2,0
				c-28.8,0-44.5,15.5-44.5,44.1C42,241.9,42,398.2,42.1,554.5c0,6,0.8,12.2,2.6,17.9c5.7,17.6,19.8,26.3,41.8,26.3
				c104.1,0,208.2,0,312.2,0c31.1,0,45.7-14.3,45.7-45.1c0.1-101.3,0-202.7,0-304c0-2.9-0.3-5.8-0.4-9.3c-3.9,0-7,0-10,0
				c-42.1,0-84.3,0.4-126.4-0.2c-25-0.3-46.3-9.4-57-33.3c-4.4-9.8-6.6-21.2-6.8-32c-0.8-40.9-0.3-81.7-0.3-122.6
				C243.6,49,243.6,45.8,243.6,41.5z M284.2,43c-0.6,3.1-1,4.1-1,5.1c0,43.6-0.2,87.2,0.1,130.7c0.1,14.9,8,22.1,23.2,22.2
				c42.9,0.1,85.8,0.1,128.8,0c2,0,4-0.5,7.9-1.1c-4.5-6.2-7.4-11.7-11.6-15.8C387.7,140.5,343.7,97,299.6,53.7
				C295.5,49.7,290,47,284.2,43z"
          />
          <path
            fill="currentColor"
            d="M263.1,419.6c0,38.7,0.1,77.3,0,116c0,14.1-5.2,20.6-17.2,22.4c-9.8,1.5-19.1-4.7-21.1-14.4
				c-0.7-3.5-1.2-7.1-1.2-10.6c-0.1-75.7-0.1-151.3,0-227c0-14,4.6-21.6,14.3-24.1c13-3.4,23.7,3.6,25,16.8
				c0.6,6.8,0.3,13.8,0.3,20.7C263.1,352.8,263.1,386.2,263.1,419.6z"
          />
          <path
            fill="currentColor"
            d="M383.6,459.4c0,25.7,0.2,51.4-0.1,77c-0.1,16.4-11.8,25.8-26,20.2c-4.9-1.9-8.8-7.6-11.9-12.4
				c-1.8-2.7-1.5-6.9-1.5-10.5c-0.1-49.7-0.1-99.4,0-149.1c0-12.3,4.5-20.3,12.6-23c14.2-4.9,26.5,3.5,26.8,19
				c0.4,19,0.1,38.1,0.1,57.1C383.6,445.1,383.6,452.2,383.6,459.4z"
          />
          <path
            fill="currentColor"
            d="M142.4,499.2c0,13.2,0.2,26.5-0.1,39.7c-0.2,7.5-2.8,14.1-10.6,17.3c-7.5,3.1-15.6,3.4-21-2.5
				c-4.1-4.5-7.2-11.4-7.4-17.4c-0.8-24.8-0.7-49.7-0.2-74.5c0.3-16.4,11.8-24.9,26.4-20.6c8.1,2.4,12.7,8.8,12.9,19.1
				C142.7,473.2,142.5,486.2,142.4,499.2C142.5,499.2,142.4,499.2,142.4,499.2z"
          />
          <path
            fill="currentColor"
            d="M469.4,186.6C411.7,129.3,354,72,296.4,14.5c-9-8.9-19.5-13.4-32.1-13.4c-59.8,0-119.7-0.4-179.5,0.2
				c-26.1,0.3-48.6,9.8-65.1,31.3C7.3,48.8,2.1,67,2.1,86.8C2,164.6,2,242.4,2,320.1c0,78.1-0.1,156.1,0,234.2
				C2.2,603,37.4,638.9,85.7,639c104.7,0.2,209.3,0.2,314,0c48.3-0.1,83.3-34.8,83.4-82.7c0.2-112.1,0-224.2,0.2-336.3
				C483.3,206.6,478.7,195.9,469.4,186.6z M282.7,32.7c56.1,55.8,112.5,111.9,168.8,167.9c-1.3,0.7-4.1-0.1-6.7-0.1
				c-41.7,0.1-83.4,0.1-125.1,0c-25,0-36.9-11.7-37-36.4C282.7,119.9,282.7,75.7,282.7,32.7z M463.1,554.7
				c0,39.3-25.2,64.4-64.7,64.4c-103.8,0.1-207.6,0.1-311.4,0c-39,0-64.8-25.7-64.9-64.6c-0.1-78.3,0-156.6,0-235
				c0-77.5,0-155,0-232.5c0-10.6,1.7-20.9,6.1-30.6c10.6-23.7,30.4-34.6,55.1-35c57.9-0.9,115.8-0.2,173.7-0.4
				c6.2,0,5.8,2.9,5.8,7.1c-0.1,45.9-0.1,91.9,0,137.8c0,15.2,4,28.8,15.4,39.8c10.6,10.3,22.9,14.9,37.6,14.9
				c46.5-0.2,93,0.1,139.4-0.2c6.5,0,8.2,1.5,8.2,8.1C463,337.1,463.1,445.9,463.1,554.7z"
          />
          <path
            fill="currentColor"
            d="M282.6,303.5c0-16.3-7.1-23.1-23.5-23.3c-10-0.1-20,0-30,0c-19.5,0-26.6,7-26.6,26.4c0,45.4,0,90.7,0,136.1
				c0,30.2,0,60.3,0,90.5c0,19.3,6.8,26.1,25.9,26.1c9.5,0,18.9,0,28.4,0c19.8,0,25.8-6.1,25.9-25.9c0-37.9,0-75.8,0-113.7
				C282.7,381,282.7,342.3,282.6,303.5z M254.5,539.5c-8.6-0.5-17.2-0.4-25.8,0c-4.6,0.2-6.2-1-6.2-5.9c0.2-75.8,0.2-151.5,0-227.3
				c0-5.4,1.8-6.5,6.7-6.3c8.6,0.3,17.3,0.5,25.8,0c6.1-0.4,7.9,1.2,7.9,7.6c-0.3,37.6-0.2,75.2-0.2,112.8c0,37-0.2,74.1,0.2,111.1
				C262.9,538.3,260.8,539.9,254.5,539.5z"
          />
          <path
            fill="currentColor"
            d="M402.9,382.2c-0.1-14.9-7.2-21.9-22-22.2c-12-0.3-23.9-0.3-35.9,0c-13.9,0.3-22,7.7-22.1,21.5
				c-0.3,52-0.3,104,0,156c0.1,14.6,8,21.5,22.7,21.7c10.8,0.2,21.7,0.1,32.5,0c18.2-0.1,24.7-6.4,24.8-24.4c0.1-25.2,0-50.3,0-75.5
				C402.9,433.7,403.1,408,402.9,382.2z M377.2,539.5c-9.2-0.2-18.4-0.4-27.5,0c-5.4,0.3-7-1.3-7-6.8c0.3-24.3,0.1-48.6,0.1-72.9
				c0-24.3,0.1-48.6-0.1-72.9c-0.1-5.2,1.1-7.3,6.8-7c9.4,0.5,18.9,0.3,28.3,0c4-0.1,5.2,1.2,5.2,5.1c-0.1,49.7-0.1,99.5,0,149.2
				C383,538.9,381.2,539.6,377.2,539.5z"
          />
          <path
            fill="currentColor"
            d="M162.4,500.4c0-12.7,0.2-25.4,0-38.1c-0.2-15.3-7.2-22.2-22.6-22.5c-11.7-0.2-23.4-0.2-35,0
				c-14.3,0.3-22.2,7.7-22.4,22.1c-0.4,25.2-0.4,50.3,0,75.5c0.2,14.6,7.9,21.7,22.4,21.9c11.9,0.2,23.9,0.3,35.9,0
				c14.6-0.3,21.4-7,21.7-21.6C162.6,525.2,162.4,512.8,162.4,500.4z M142.4,534.6c0,3.4-0.7,5-4.5,4.9c-10.3-0.2-20.5-0.3-30.8,0
				c-4.4,0.1-4.9-1.9-4.9-5.5c0.2-11.6,0.1-23.2,0.1-34.8c0-11.3,0.2-22.6-0.1-33.9c-0.1-4.2,0.9-5.9,5.5-5.7c10,0.3,20,0.2,30,0
				c3.6-0.1,4.8,0.9,4.8,4.6C142.3,487.7,142.3,511.1,142.4,534.6z"
          />
        </g>
      </svg>
    ),
  },
  qrCode: {
    viewBox: "0 0 448 512",
    icon: (
      <g className="prefix__fa-group">
        <path
          className="prefix__fa-secondary"
          fill="currentColor"
          d="M0 480h192V288H0zm64-128h64v64H64zM256 32v192h192V32zm128 128h-64V96h64zM0 224h192V32H0zM64 96h64v64H64z"
          opacity={0.4}
        />
        <path
          className="prefix__fa-primary"
          fill="currentColor"
          d="M416 480h32v-32h-32zm-64 0h32v-32h-32zm64-192v32h-64v-32h-96v192h64v-96h32v32h96V288z"
        />
      </g>
    ),
  },
  list: {
    viewBox: "0 0 512 512",
    icon: (
      <path
        fill="currentColor"
        d="M80 48H16A16 16 0 000 64v64a16 16 0 0016 16h64a16 16 0 0016-16V64a16 16 0 00-16-16zm0 160H16a16 16 0 00-16 16v64a16 16 0 0016 16h64a16 16 0 0016-16v-64a16 16 0 00-16-16zm0 160H16a16 16 0 00-16 16v64a16 16 0 0016 16h64a16 16 0 0016-16v-64a16 16 0 00-16-16zm416-136H176a16 16 0 00-16 16v16a16 16 0 0016 16h320a16 16 0 0016-16v-16a16 16 0 00-16-16zm0 160H176a16 16 0 00-16 16v16a16 16 0 0016 16h320a16 16 0 0016-16v-16a16 16 0 00-16-16zm0-320H176a16 16 0 00-16 16v16a16 16 0 0016 16h320a16 16 0 0016-16V88a16 16 0 00-16-16z"
      />
    ),
  },
  grid: {
    viewBox: "0 0 512 512",
    icon: (
      <path
        fill="currentColor"
        d="M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
      />
    ),
  },
  stem: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 19.92 15.9"
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#44c8f5"
            d="m1.79,5.12c0-.72-.04-1.46,0-2.2C1.9,1.33,3.26.06,4.85,0,5.15,0,5.46,0,5.76,0,6.9,0,6.97.07,6.97,1.23s-.04,1.25-1.27,1.25c-1.42,0-1.48.07-1.48,1.5v1.13c.56.11,1.19.08,1.56.37.26.21.18.86.2,1.32.05,1.37-1.09.68-1.77.99,0,1.33.05,2.7,0,4.07-.07,1.75-1.54,3.07-3.27,3.06-.61,0-.95-.21-.92-.87,0-.27,0-.55,0-.83,0-.51.22-.81.73-.79.83.04,1.04-.41,1.03-1.14-.02-1.18,0-2.36,0-3.53C-.04,7.53-.02,7.53,0,6.06c.03-1.32,1.08-.64,1.79-.96"
          />
          <path
            fill="#44c8f5"
            d="m13.5,11.06c-.57.66-.9,1.03-1.22,1.42-.47.58-.87.44-1.35-.04-.5-.5-.56-.9,0-1.36.38-.32.75-.65,1.34-1.17-.52-.42-.9-.73-1.28-1.04-.55-.45-.63-.85-.07-1.42.54-.54.95-.58,1.41.02.3.39.6.79.9,1.18.14,0,.27,0,.41-.01.28-.37.56-.75.85-1.12.47-.61.89-.63,1.47-.07s.49.96-.07,1.41c-.37.29-.73.59-1.16.95.56.58.96,1.02,1.39,1.43.52.49.18.82-.17,1.16-.37.36-.72.77-1.22.19-.37-.44-.72-.9-1.23-1.54"
          />
          <path
            fill="#3680c3"
            d="m6.97,9.99c.08-1.99.59-3.85,1.76-5.5.26-.37.56-.69.99-.27.38.37,1.19.58.65,1.41-1.87,2.88-1.87,5.78,0,8.66.54.83-.28,1.04-.66,1.41-.43.42-.73.09-.99-.28-1.15-1.62-1.66-3.46-1.76-5.42"
          />
          <path
            fill="#3680c3"
            d="m19.92,9.95c-.09,1.96-.59,3.8-1.73,5.43-.28.4-.58.73-1.05.28-.38-.38-1.14-.59-.6-1.43,1.85-2.85,1.85-5.73,0-8.58-.55-.84.23-1.04.61-1.42.47-.46.77-.1,1.04.3,1.15,1.63,1.64,3.46,1.73,5.43"
          />
        </g>
      </svg>
    ),
  },
  overall: {
    viewBox: "0 0 200 200",
    icon: (
      <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13.37 15.62"
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#44c8f5"
            d="m10.03,3.35h-5.07c1.18,1.41,2.23,2.69,3.32,3.93.36.41.37.66,0,1.08-1.08,1.23-2.12,2.5-3.32,3.93h5.06c0,1.11-.01,2.21-.02,3.32-2.69,0-5.37,0-8.06.02-.79,0-1.38-.35-1.73-1.01-.38-.72-.24-1.42.31-2.05,1.22-1.39,2.4-2.83,3.64-4.21.37-.41.38-.65,0-1.07-1.2-1.33-2.33-2.72-3.52-4.07C.09,2.58-.21,1.91.17,1.1.56.29,1.24,0,2.13,0c2.62.03,5.25.02,7.88.03,0,1.11.01,2.21.02,3.32"
          />
          <path
            fill="#3680c3"
            d="m10.03,3.35c0-1.11-.01-2.21-.02-3.32.71,0,1.42-.03,2.13,0,.77.02,1.2.45,1.23,1.22.03.77.01,1.54,0,2.31,0,.15,0,.34-.09.44-.67.83-1.6.42-2.42.44-.64.02-.88-.47-.83-1.09"
          />
          <path
            fill="#3680c3"
            d="m10.01,15.6c0-1.11.01-2.21.02-3.32-.01-.82.37-1.14,1.2-1.14,2.15,0,2.15-.03,2.15,2.13,0,.34,0,.68,0,1.02-.02.86-.47,1.31-1.33,1.32-.68,0-1.36,0-2.03-.01"
          />
        </g>
      </svg>
    ),
  },
};

export default iconDefinitions;
